import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Accordion, Alert, Badge, Button, ButtonGroup, CloseButton, Col, Container, FloatingLabel, Form, Image, InputGroup, Modal, ModalBody, ProgressBar, Row, Spinner, Tab, Table, Tabs, Toast, ToggleButton } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { LoginInfo } from '../../App';
import ImageFile from '../../domain/ImageFile';
import * as ImageUtil from '../../service/ImageUtil';
import ApiFetch from '../ApiFetch';
import CampaignMessage from '../CampaignMessage';
import Dialog from '../Dialog';
import Footer from '../Footer';
import Header from '../Header';
import Category from '../Category';
import EXIF from 'exif-js';
import extractChunks from 'png-chunks-extract/index'
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import  {  Typeahead  }  from  'react-bootstrap-typeahead' ;
import  'react-bootstrap-typeahead/css/Typeahead.css' ;
import Cropper from 'react-easy-crop'
import {getStyleList,setStyle,deleteStyleList} from '../../service/AIGenerateService';
import Questionnaire from '../Questionnaire';
import RegistOrLogin from '../RegistOrLogin';
import AITalk from '../AITalk';
import { Bar } from 'react-chartjs-2';
import { login } from '../../service/LoginService';
import ExifReader from 'exifreader';
import TagSelector from '../TagSelector';
import Thumb from '../common/Thumb';
import { planDialog } from '../../service/CommonUtil';

const UploadVideo = (props) => {
    function getAIGeneraleImageList(userId,page){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/generated/"+userId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function getAIGeneraleImageFile(procId){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImage/"+procId+"/0").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function deleteAIGeneraleImageFile(procIdList){
        return new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/generatedHistory",{procIdList:procIdList}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function getStatusCount(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/statusCount").then((r)=>{
            return r.json()
        })
    }
    function getStatus(procId){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/status/"+procId).then((r)=>{
            return r.json()
        })
    }
    function getPoint(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/point").then((r)=>{
            return r.json()
        })
    }
    function txt2img(booking,style,enterJpPrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sampler,steps,scale,denoisingStrength,seed,width,height,hires){
        if(false === booking) setAiProccessing(true)
        if(enterJpPrompt){
            setJpPromptTranslating(true)
            document.getElementById("sd-prompt").value = ""
        }
        new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/txt2img",
            {mode:"txt2img",booking:booking ? 1 : 0,style:style,enterJpPrompt:enterJpPrompt,jpPrompt:jpPrompt,prompt:prompt,negativePrompt:negativePrompt,styleP:styleP,styleNP:styleNP,sampler:sampler,steps:steps,scale:scale,denoisingStrength:denoisingStrength,seed:seed,width:width,height:height,hires:hires}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    if(booking){
                        dialog(t("common.info"),"予約しました。")
                    }
                    if(json.data.translatedPrompt){
                        document.getElementById("sd-prompt").value = json.data.translatedPrompt
                    }
                    setPoint(json.data.afterPoint)
                } else {
                    let error = json.errors.join("\r\n")
                    if(error.indexOf("ポイントが不足しています。") !== -1){
                        dialog("エラー",
                        <Container>
                            ポイントが不足しています。<br /><br />
                            ポイント回復方法
                            <ul>
                                <li><Link to={"/legal"}>無制限プラン</Link>でポイント消費することなく生成できます。</li>
                                <li>翌日まで待てば100ポイント回復。<br />
                                    活動実績により変動。※アカウント登録し、SMS認証を行っていること。「マイページ」の実績➡総利用ポイント<br />基準は定期的に見直されます。</li>
                                <li>イラストを投稿することで数ポイント回復。</li>
                                <li>過去6ヵ月間の平均閲覧数に応じて回復ポイントが変動。</li>
                                <li>今日のお題に参加すると投稿時に回復するポイントが2倍。</li>
                            </ul>
                        </Container>)
                    } else {
                        dialog("エラー",json.errors.join("\r\n"))
                    }
                    if(false === booking) setAiProccessing(false)
                }
                if(enterJpPrompt){
                    setJpPromptTranslating(false)
                }
                return json.result
            })
        })
    }
    function img2img(booking,style,img,enterJpPrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sampler,steps,scale,denoisingStrength,seed,width,height){
        if(false === booking) setAiProccessing(true)
        if(enterJpPrompt){
            setJpPromptTranslating(true)
            document.getElementById("sd-prompt").value = ""
        }
        new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/img2img",
            {mode:"img2img",style:style,img:img,enterJpPrompt:enterJpPrompt,jpPrompt:jpPrompt,prompt:prompt,negativePrompt:negativePrompt,styleP:styleP,styleNP:styleNP,sampler:sampler,steps:steps,scale:scale,denoisingStrength:denoisingStrength,seed:seed,width:width,height:height}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    if(booking){
                        dialog(t("common.info"),"予約しました。")
                    }
                    if(json.data.translatedPrompt){
                        document.getElementById("sd-prompt").value = json.data.translatedPrompt
                    }
                    setPoint(json.data.afterPoint)
                } else {
                    let error = json.errors.join("\r\n")
                    if(error.indexOf("ポイントが不足しています。") !== -1){
                        dialog("エラー",
                        <Container>
                            ポイントが不足しています。<br /><br />
                            ポイント回復方法
                            <ul>
                                <li>翌日まで待てば基準ポイントまで回復。※総利用ポイント2000毎に1枚の投稿があること。「マイページ」の実績➡総利用ポイント。<br />基準は定期的に見直されます。</li>
                                <li>イラストを投稿することで数ポイント回復。</li>
                                <li>過去6ヵ月間の平均閲覧数に応じて回復ポイントが変動。</li>
                                <li>今日のお題に参加すると投稿時に回復するポイントが2倍。</li>
                            </ul>
                        </Container>)
                    } else {
                        dialog("エラー",json.errors.join("\r\n"))
                    }
                    if(false === booking) setAiProccessing(false)
                }
                if(enterJpPrompt){
                    setJpPromptTranslating(false)
                }
                return json.result
            })
        })
    }
    function getOdai(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/odai/latest").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function calcPoint(postCount){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/point/calc/"+postCount).then((r)=>{
            return r.json()
        })
    }
    function getSeriesList(userId){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/series/list/"+userId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function getUsersByDay(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/users").then((r)=>{
            return r.json()
        })
    }
    function tagSearch(word){
        return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tag/search/",{word:word}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getEvent(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/event/hold/").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function prepareUpload(){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/upload/prepareUploadVideo/").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getTagLatest(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tag/latest/video").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲーション
    const navigate = useNavigate()
    const param = useParams()

    // 最新タグ
    const [tagLatest,setTagLatest] = useState([])

    // イベント一覧
    const [eventList,setEventList] = useState([])
    const [eventTag,setEventTag] = useState("")

    useEffect(() => {
        getEvent().then(r => {
            if(r.result){
                setEventList(r.data)
            }
        })
    },[])

    // お題
    const [odai,setOdai] = useState([])
    const [useOdai,setUseOdai] = useState(false)

    // フラグ
    const [batchMode,setBatchMode] = useState(false)
    const [useFilename,setUseFilename] = useState(false)
    const [notReadPromptInfo,setNotReadPromptInfo] = useState(false)
    const [promptInfoPublication,setPromptInfoPublication] = useState(true)

    // アップロード処理
    const [batchUploading,setBatchUploading] = useState(false)
    const [batchProgressNow,setBatchProgressNow] = useState(0)
    const [batchProgressLabel,setBatchProgressLabel] = useState(0)
    const [uploading,setUploading] = useState(false)
    const [progressNow,setProgressNow] = useState(0)
    const [progressLabel,setProgressLabel] = useState(0)
    const maxFileSize = 31457280000
    // 104857600 100MB
    // 262144000 200MB
    // 31457280000 30GB

    // AIでの生成関連
    const [useAiGenerate,setUseAiGenerate] = useState(param.generate === "generate" || false) // 生成を使用
    const [jpPromptTranslating,setJpPromptTranslating] = useState(false) // 翻訳中
    const [aiProccessing,setAiProccessing] = useState(false) // 生成処理中
    const [qualityTags,setQualityTags] = useState(true)
    const [point,setPoint] = useState(0)
    const [pointCost,setPointCost] = useState(21)
    const [calcPointInfo,setCalcPointInfo] = useState([])
    const [sdStyle,setSdStyle] = useState("illust")
    const [sdResolution,setSdResolution] = useState("512x512")
    const [sdSampler,setSdSampler] = useState("Euler a")
    const [sdSteps,setSdSteps] = useState(20)
    const [sdScale,setSdScale] = useState(7)
    const [sdDenoisingStrength,setSdDenoisingStrength] = useState(0.6)
    const [sdSeed,setSdSeed] = useState(-1)
    const [aiGenerateImageList,setAIGenerateImageList] = useState([]) // AI生成履歴
    const [displayAIGeneratedPanel,setDisplayAIGeneratedPanel] = useState(false) // AI生成履歴パネルの表示
    const [aiGenerateImagePage,setAIGenerateImagePage] = useState(-1) // AI生成履歴パネルのページ
    const [aiGenerateReset,setAIGenerateReset] = useState(false) // AI生成履歴を再取得するためのフラグ
    const [generateMode,setGenerateMode] = useState("txt2img") // 生成モード
    const [showSettings,setShowSettings] = useState(false) // settings表示
    const [img2ImgFile,setImg2ImgFile] = useState() // img2imgのbase64

    useEffect(() => {
        if(param.generate === "generate"){
            aiGenInitHandler(true)
        }
    },[param.generate])

    let procId = ""
    useEffect(() => {
        if(aiGenerateImagePage > 0 && loginInfo.result){
            getAIGeneraleImageList(loginInfo.userId,aiGenerateImagePage).then(r => {
                if(r.result){
                    if(r.data.length > 0){
                        if(aiGenerateImagePage === 1){
                            setAIGenerateImageList([].concat(r.data))
                        } else {
                            setAIGenerateImageList(aiGenerateImageList.concat(r.data))
                        }
                    } else {
                        if(aiGenerateImagePage === 1){
                            setAIGenerateImageList([])
                            //dialog("","履歴がありません。AI生成機能を利用してみませんか？")
                        }
                    }
                } else {
                    setAIGenerateImageList([])
                    dialog("確認",r.errors)
                }
            })
        }
    },[loginInfo,aiGenerateImagePage,aiGenerateReset])

    // 画像遅延ロード
    useEffect(() => {
        document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[aiGenerateImageList])

    // 投稿遅延ロード
    const options = {
        root: null,
        rootMargin: "500px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                //imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (aiGenerateImagePage * 30 - 1) ){
                    setAIGenerateImagePage(aiGenerateImagePage+1)
                }
              }
        })
    }, options);

    // 編集情報
    const [editImageNo,setEditImageNo] = useState(-1)
    const [editImageTargetNo,setEditImageTargetNo] = useState(-1)
    const [editLabel,setEditLabel] = useState("モザイク描画")
    const [previewSource,setPreviewSource] = useState("")
    const [previewFlg,setPreviewFlg] = useState(false)
    const ref = React.createRef()
    const styleRef = React.createRef()
    const [styleOptions,setStyleOptions] = useState([])
    const [styleSelected,setStyleSelected] = useState([])
    const [generateMethodSelected,setGenearteMethodSelected] = useState([])
    const [optionSelected,setOptionSelected] = useState([])
    const [enterJpPrompt,setEnterJpPrompt] = useState(false)
    const [jpCost,setJpCost] = useState(0)
    const [aiTalkShow,setAiTalkShow] = useState(false)
    const [tagSelectorShow,setTagSelectorShow] = useState(false)
    const [bookingDate,setBookingDate] = useState("")
    const [bookingTime,setBookingTime] = useState("")
    const [tagOptions, setTagOptions] = useState([])
    const [tag, setTag] = useState([])

    // 投稿完了後
    const [postedGroupId,setPostedGroupId] = useState("")
    const [url,setURL] = useState("")
    const [imgUrl,setImgURL] = useState("")
    let timer
    let uploadProgressNo = 0
    let oldUploadProgressNo = 1

    function uploadSelect(files){
        // アップロード開始
        setUploading(true)
        // 入力フォーム無効化
        setDisabled()
        let batch = document.getElementById("batch").checked
        if(batch){
            setBatchUploading(true)
            timer = setInterval(() => {
                if(!uploading){
                    if(uploadProgressNo < files.length){
                        if(uploadProgressNo !== oldUploadProgressNo){
                            upload([files[uploadProgressNo]],tempGroupId)
                            let per = Math.floor((uploadProgressNo + 1) / files.length * 100)
                            let label = ""
                            if(per === 100){
                                label = "登録中"
                            } else {
                                label = per + "%"
                            }
                            setBatchProgressNow(per)
                            setBatchProgressLabel(label)
                        }
                        oldUploadProgressNo = uploadProgressNo
                    }
                }
            },500)
        } else {
            upload(files,tempGroupId)
        }
    }

    /**
     * 入力フォームを無効化する
     */
    function setDisabled(){
        let elements = ["batch","title","description","original","limited-publication",
            "ai-model","prompt","negative-prompt","delete-password"
            ,"noise","steps","scale","seed","sampler","strength","mask-blur",
            "clip-skip","controlnet-enabled","controlnet-module","controlnet-model","controlnet-weight",
            "ensd","hires-upscale","hires-upscaler","raw-info"
        ]
        elements.forEach(id => {
            if(loginInfo.result && id === "delete-password") return
            let elm = document.getElementById(id)
            if(elm !== null)
            elm.setAttribute("disabled",true)
        })
    }

    /**
     * 入力フォームの無効化を解除する
     */
    function unsetDisabled(){
        let elements = ["batch","title","description","original","limited-publication",
            "ai-model","prompt","negative-prompt","delete-password"
            ,"noise","steps","scale","seed","sampler","strength","mask-blur",
            "clip-skip","controlnet-enabled","controlnet-module","controlnet-model","controlnet-weight",
            "ensd","hires-upscale","hires-upscaler","raw-info"
        ]
        elements.forEach(id => {
            if(loginInfo.result && id === "delete-password") return
            let elm = document.getElementById(id)
            if(elm !== null)
            elm.removeAttribute("disabled")
            
        })
    }

    /**
     * 入力フォームの内容をリセットする
     */
    function deleteFormValue(){
        let elements = ["batch","title","description"]
        elements.forEach(id => {
            let elm = document.getElementById(id)
            elm.value = ""
        })
        document.getElementById("batch").checked = false
        //document.getElementById("original").checked = false
        //document.getElementById("limited-publication").checked = false

        document.getElementById("ai-model").value = "no-select"
        document.getElementById("prompt").value = ""
        document.getElementById("negative-prompt").value = ""
        document.getElementById("noise").value = ""
        document.getElementById("steps").value = ""
        document.getElementById("scale").value = ""
        document.getElementById("seed").value = ""
        document.getElementById("sampler").value = ""
        document.getElementById("strength").value = ""
        document.getElementById("mask-blur").value = ""
        document.getElementById("model-version").value = ""
        document.getElementById("clip-skip").value = ""
        document.getElementById("controlnet-enabled").value = ""
        document.getElementById("controlnet-module").value = ""
        document.getElementById("controlnet-model").value = ""
        document.getElementById("controlnet-weight").value = ""
        document.getElementById("ensd").value = ""
        document.getElementById("hires-upscale").value = ""
        document.getElementById("hires-upscaler").value = ""
        document.getElementById("raw-info").value = ""
        setVAE([])
        setGPU([])
        setVRAM([])

        if(loginInfo.length === 0){
            let deletePassword = document.getElementById("delete-password")
            deletePassword.value = ""
        }
        setFileList([])
    }

    /**
     * 現在の情報を削除する
     */
    function deleteSelectedFormValue(){
        document.getElementById("ai-model").value = "no-select"
        document.getElementById("prompt").value = ""
        document.getElementById("negative-prompt").value = ""
        document.getElementById("noise").value = ""
        document.getElementById("steps").value = ""
        document.getElementById("scale").value = ""
        document.getElementById("seed").value = ""
        document.getElementById("sampler").value = ""
        document.getElementById("strength").value = ""
        document.getElementById("mask-blur").value = ""
        document.getElementById("model-version").value = ""
        document.getElementById("clip-skip").value = ""
        document.getElementById("controlnet-enabled").value = ""
        document.getElementById("controlnet-module").value = ""
        document.getElementById("controlnet-model").value = ""
        document.getElementById("controlnet-weight").value = ""
        document.getElementById("ensd").value = ""
        document.getElementById("hires-upscale").value = ""
        document.getElementById("hires-upscaler").value = ""
        document.getElementById("raw-info").value = ""
        setVAE([])
        setGPU([])
        setVRAM([])

        if(fileList.length > 0){
            fileList.filter((d,i) => i === editImageNo).map(r => {
                r.prompt = ""
                r.software = "no-select"
                r.softwareLocked = "0"
                r.modelHash = ""
                r.rawInfo = ""
                r.useAIGeneration = false
                r.comment = {uc:"",noise:"",steps:"",scale:"",seed:"",sampler:"",strength:"",maskBlur:"",
                    clipSkip:"",controlNetEnabled:"",controlNetModule:"",controlNetModel:"",controlNetWeight:"",ensd:"",
                    hiresUpscale:"",hiresUpscaler:""
                }
                r.error = false
                return r
            })
        }
    }

    const [tempGroupId,setTempGroupId] = useState()
    const [uploadCompleted,setUploadCompleted] = useState(false)

    function uploadVideo(files,tempGroupId) {
        setUploading(true)
        //サーバに保存する処理　画像のURLが戻される
        let fd = new FormData()
        fd.append("tempGroupId",tempGroupId)
        fd.append("file[]",files[0].file)
        let req = new XMLHttpRequest()
        req.open("POST",ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/upload/videoFile")
        req.withCredentials = true
        req.onreadystatechange = () => {
            if(req.readyState === 4 && req.status === 200){
                if(req.responseText !== ""){
                    var r = JSON.parse(req.responseText)
                    if(r.result){
                      setUploadCompleted(true)
                    } else {
                      alert(r.errors)
                    }
                    setUploading(false)
                }
            }
        }
        req.onerror = () => {
          setUploading(false)
          setProgressNow(0)
          setProgressLabel(0)
          alert("通信エラーが発生しました。")
        }
        req.upload.onprogress = (e) => {
            let per = Math.floor(e.loaded / e.total * 100)
            let label = ""
            if(per === 100){
                label = "登録中"
            } else {
                label = per + "%"
            }
            setProgressNow(per)
            setProgressLabel(label)
        }
        req.send(fd)
    }

    function upload(files,tempGroupId){
        let fd = new FormData()
        let batch = document.getElementById("batch").checked
        let bookingDatetime = ""
        if(bookingDate.length > 0 && bookingTime.length > 0){
            bookingDatetime = bookingDate + " " + bookingTime
        } else {
            bookingDatetime = ""
        }
        // 一括投稿モードかつファイル名利用フラグが有効の場合、ファイル名から拡張子をとったものをタイトルに設定
        if(batch && useFilename){
            let title = files[0].file.name.replace(/\..[^.]+?$/,"").substring(0,100)
            if(title === ""){
                title = "無題"
            }
            fd.append("title",title)
        } else {
            fd.append("title",document.getElementById("title").value)
        }
        fd.append("tempGroupId",tempGroupId)
        fd.append("styleOfPainting",styleOfPainting)
        fd.append("original",optionSelected.findIndex(v => v.value === "original") !== -1 ? "1" : "0")
        fd.append("bookingDatetime",bookingDatetime)
        fd.append("ageLimit",ageLimit)
        fd.append("sexualExpression",sexualExpression)
        fd.append("limitedPublication",optionSelected.findIndex(v => v.value === "limitedPublication") !== -1 ? "1" : "0")
        fd.append("displayNewList",optionSelected.findIndex(v => v.value === "newPostHidden") !== -1 || batch ? "1" : "0")
        fd.append("displayRanking",optionSelected.findIndex(v => v.value === "rankingHidden") !== -1 ? "1" : "0")
        fd.append("sensitive",optionSelected.findIndex(v => v.value === "sensitive") !== -1 ? "1" : "0")
        fd.append("editImageNo",editImageNo) // 標準サムネイル番号
        fd.append("seriesId",series.id !== undefined ? series.id : "") // シリーズID
        fd.append("tempGroupId",tempGroupId) // 投稿ID

        if(batch){
            if(uploadProgressNo === 0){
                fd.append("insideThumbnail",insideThumbnail !== undefined ? insideThumbnail : "")
                fd.append("outsideThumbnail",outsideThumbnail !== undefined ? outsideThumbnail : "")
                if(questionInfo !== undefined){
                    if(questionInfo.options.filter(v => v.length > 0).length > 0){
                        fd.append("questionDeadlineDatetime",questionInfo.deadlineDate + " " + questionInfo.deadlineTime)
                        questionInfo.options.filter(v => v.length > 0).forEach(d => {
                            fd.append("questionOptions[]",d)
                        })
                    }
                }
            }
        } else {
            fd.append("insideThumbnail",insideThumbnail !== undefined ? insideThumbnail : "")
            fd.append("outsideThumbnail",outsideThumbnail !== undefined ? outsideThumbnail : "")
            if(questionInfo !== undefined){
                if(questionInfo.options.filter(v => v.length > 0).length > 0){
                    fd.append("questionDeadlineDatetime",questionInfo.deadlineDate + " " + questionInfo.deadlineTime)
                    questionInfo.options.filter(v => v.length > 0).forEach(d => {
                        fd.append("questionOptions[]",d)
                    })
                }
            }
        }
        fd.append("request",document.getElementById("request").value)
        let description = document.getElementById("description").value

        let aiModel = document.getElementById("ai-model")
        if(aiModel.value !== "no-select"){
            if(description.indexOf(aiModel.value) === -1){
                description += "\n#" + aiModel.value.replace(/-/g,"_").replace(/\s/g,"_").replace(/\(|\)/g,"_").replace(/_+/g,"_").replace(/_$/g,"")
                if(description.indexOf("#AIイラスト") === -1){
                    //description += " #AIイラスト #AIart"
                }
            }
        }
        // イベントタグ
        if(eventTag.length > 0 && description.indexOf("#"+eventTag) === -1){
            description += "\n#" + eventTag
        }
        // タグ
        if(tag.length > 0){
            description += "\n" + tag.map(d => "#"+d).join(" ")
        }

        if(generateMethodSelected.findIndex(v => v.value === "t2i") !== -1) description += " #t2i"
        if(generateMethodSelected.findIndex(v => v.value === "i2i") !== -1) description += " #i2i"
        if(generateMethodSelected.findIndex(v => v.value === "inpaint") !== -1) description += " #inpaint"
        if(generateMethodSelected.findIndex(v => v.value === "outpaint") !== -1) description += " #outpaint"
        if(generateMethodSelected.findIndex(v => v.value === "ip2p") !== -1) description += " #ip2p"
        if(generateMethodSelected.findIndex(v => v.value === "ControlNet") !== -1) description += " #ControlNet"

        let promptFound = false
        for(let i = 0;i < files.length;i++){
            let useMosaic = files[i].useMosaic
            let imageDataOriginal = files[i].imageDataOriginal
            fd.append("useMosaic[]",useMosaic ? "1" : "0")
            fd.append("imageDataOriginal[]",useMosaic ? base64ToFile(imageDataOriginal.replace(/^.*,/, ''),files[i].file.name,"image/png") : "")
            // 使用モデルは必須
            let software = files[i].software ? files[i].software : ""
            fd.append("software[]",software.replace(/-/g,"_").replace(/\s/g,"_").replace(/\(|\)/g,"_").replace(/_+/g,"_").replace(/_$/g,""))

            if(promptInfoPublication){
                let modelHash = files[i].modelHash ? files[i].modelHash : ""
                let prompt = files[i].prompt ? files[i].prompt : ""
                let negativePrompt = files[i].comment !== undefined ? files[i].comment.uc : ""
                let noise = files[i].comment !== undefined ? files[i].comment.noise : ""
                let steps = files[i].comment !== undefined ? files[i].comment.steps : ""
                let scale = files[i].comment !== undefined ? files[i].comment.scale : ""
                let seed = files[i].comment !== undefined ? files[i].comment.seed : ""
                let sampler = files[i].comment !== undefined ? files[i].comment.sampler : ""
                let strength = files[i].comment !== undefined ? files[i].comment.strength : ""
                let maskBlur = files[i].comment !== undefined ? files[i].comment.maskBlur : ""
                let clipSkip = files[i].comment !== undefined ? files[i].comment.clipSkip : ""
                let controlNetEnabled = files[i].comment !== undefined ? files[i].comment.controlNetEnabled : ""
                let controlNetModule = files[i].comment !== undefined ? files[i].comment.controlNetModule : ""
                let controlNetModel = files[i].comment !== undefined ? files[i].comment.controlNetModel : ""
                let controlNetWeight = files[i].comment !== undefined ? files[i].comment.controlNetWeight : ""
                let ensd = files[i].comment !== undefined ? files[i].comment.ensd : ""
                let hiresUpscale = files[i].comment !== undefined ? files[i].comment.hiresUpscale : ""
                let hiresUpscaler = files[i].comment !== undefined ? files[i].comment.hiresUpscaler : ""
                let rawInfo = files[i].rawInfo !== undefined ? files[i].rawInfo : ""
                let vae = files[i].vae !== undefined ? files[i].vae : ""
                let gpu = files[i].gpu !== undefined ? files[i].gpu : ""
                let vram = files[i].vram !== undefined ? files[i].vram : ""
                let useAIGeneration = files[i].useAIGeneration ? 1 : 0
                if(!promptFound && (prompt.trim().length > 0 || negativePrompt.trim().length > 0)){
                    promptFound = true
                }
                fd.append("modelHash[]",modelHash)
                fd.append("prompt[]",prompt)
                fd.append("negativePrompt[]",negativePrompt)
                fd.append("noise[]",noise)
                fd.append("steps[]",steps)
                fd.append("scale[]",scale)
                fd.append("seed[]",seed)
                fd.append("sampler[]",sampler)
                fd.append("strength[]",strength)
                fd.append("maskBlur[]",maskBlur)
                fd.append("clipSkip[]",clipSkip)
                fd.append("controlNetEnabled[]",controlNetEnabled)
                fd.append("controlNetModule[]",controlNetModule)
                fd.append("controlNetModel[]",controlNetModel)
                fd.append("controlNetWeight[]",controlNetWeight)
                fd.append("ensd[]",ensd)
                fd.append("hiresUpscale[]",hiresUpscale)
                fd.append("hiresUpscaler[]",hiresUpscaler)
                fd.append("rawInfo[]",rawInfo)
                fd.append("vae[]",vae)
                fd.append("gpu[]",gpu)
                fd.append("vram[]",vram)
                fd.append("useAIGeneration[]",useAIGeneration)
            }
        }
        if(promptFound){
            description += " #プロンプトあり"
        }
        fd.append("description",description)
        if(loginInfo.result === false){
            fd.append("deletePassword",document.getElementById("delete-password").value)
        }
        for(let i = 0;i < files.length;i++){
            //fd.append("file[]",files[i].useMosaic === "1" ? base64ToFile(files[i].imageDataEdited.replace(/^.*,/, ''),files[i].file.name,"image/png") : files[i].file)
        }
        let req = new XMLHttpRequest()
        req.open("POST",ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/upload/video")
        req.withCredentials = true
        req.onreadystatechange = () => {
            if(req.readyState === 4 && req.status === 200){
                if(req.responseText !== ""){
                    var r
                    try {
                        r = JSON.parse(req.responseText)
                    } catch(error){
                        clearInterval(timer)
                        unsetDisabled()
                        setBatchProgressNow(0)
                        setBatchProgressLabel(0)
                        setBatchUploading(false)
                        setUploading(false)
                        dialog("エラー",req.responseText)
                    }
                    if(r.result){
                        let title = document.getElementById("title")
                        let titleValue = title.value

                        if(batch && fileList.length !== 1){
                            console.log(uploadProgressNo+1,fileList.length)
                            if(uploadProgressNo + 1 === fileList.length){
                                clearInterval(timer)
                                // 入力内容をリセット
                                deleteFormValue()
                                unsetDisabled()
                                setBatchProgressNow(0)
                                setBatchProgressLabel(0)
                                setBatchUploading(false)
                                setUploading(false)
                                dialog("確認","投稿完了しました。")
                                uploadProgressNo = 0
                                oldUploadProgressNo = 1
                            }
                        } else {
                            // 予約投稿でなければリンク共有メッセージを出す
                            if(bookingDate === ""){
                                // 投稿ID
                                setPostedGroupId(r.groupId)
                                // タグ
                                let tags = r.tags.filter(tag => {
                                    // 自動で追加するタグは除外する
                                    return tag !== "AIイラスト"
                                }).map(tag => "#" + tag).join(" ")
                                // サムネイルURL
                                setImgURL(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/video"+r.img)
                                // ツイートURL
                                setURL("https://twitter.com/intent/tweet?ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Emention%7Ctwgr%5Eourt_official&text="
                                    + encodeURIComponent("「アワートAI」AIイラスト無料生成&投稿サイトに投稿しました！\nタイトル：「" + titleValue + "」\n" + ApiFetch.API_PROTOCOL+"//ourt-ai.work/image/"+r.groupId + "\n#アワートAI #AIイラスト #AIart")
                                )
                            } else {
                                dialog("確認","予約投稿が完了しました。")
                            }
                            // 入力内容をリセット
                            deleteFormValue()
                            unsetDisabled()
                            // アップロード終了
                            setUploading(false)
                        }
                        setTempThumbnail()
                        setEventTag("")
                        uploadProgressNo++
                    } else {
                        clearInterval(timer)
                        unsetDisabled()
                        setBatchProgressNow(0)
                        setBatchProgressLabel(0)
                        setBatchUploading(false)
                        setUploading(false)
                        dialog("エラー",r.errors.join("\r\n"))
                    }
                    setProgressNow(0)
                    setProgressLabel(0)
                }
            }
        }
        req.onerror = () => {
            clearInterval(timer)
            setUploading(false)
            unsetDisabled()
            setProgressNow(0)
            setProgressLabel(0)
            setBatchProgressNow(0)
            setBatchProgressLabel(0)
            setBatchUploading(false)
            setUploading(false)
            dialog("エラー","通信エラーが発生しました。")
        }
        req.upload.onprogress = (e) => {
            let per = Math.floor(e.loaded / e.total * 100)
            let label = ""
            if(!batch && per === 100){
                label = "登録中"
            } else {
                label = per + "%"
            }
            setProgressNow(per)
            setProgressLabel(label)
        }
        req.send(fd)
    }

    // 画像設定
    const [fileList, setFileList] = useState([])
    const [fileSize, setFileSize] = useState(0)
    const [fileSizeByte, setFileSizeByte] = useState(0)
    const [fileSizeOver,setFileSizeOver] = useState(false)

    useEffect(() => {
        if(loginInfo.result === false){
            //navigate("/")
        }
        if(loginInfo.result && loginInfo.status !== 0){
            dialog(t("common.error"),"アカウントは利用できません。")
        }
        if(loginInfo.result){
            // シリーズ
            getSeriesList(loginInfo.userId).then(r => {
                if(r.result){
                    let list = []
                    for(let i = 0;i < r.data.length;i++){
                        list.push({"label":r.data[i].info.series_name,"id":r.data[i].info.series_id})
                    }
                    setSeriesList(list)
                }
            })
        }
    },[loginInfo])

    useEffect(() => {
        // お題
        getOdai().then(r => {
            if(r.result && r.data.length > 0){
                setOdai(r.data[0].odai)
            }
        })
        // ポイント
        getPoint().then(r => {
            if(r.result){
                setPoint(r.point)
            } else {
                dialog("エラー",r.errors)
            }
        })
        // 時間帯別利用者数
        getUsersByDay().then(r => {
            if(r.result){
                setUserList(<Bar data={createGraphData(r.data.list,"時間帯別利用者数")} />)
            }
        })
        // 最新タグ
        getTagLatest().then(r => {
            if(r.result){
                setTagLatest(r.data)
            }
        })
    },[])

    const [videoLoaded,setVideoLoaded] = useState()

    useEffect(() => {
        // タイトル設定
        document.querySelector("title").textContent = "イラスト投稿 AIイラスト自動生成 完全無料 - ourt AI"

        // ファイルサイズ合計計算
        let size = 0
        for(let i = 0;i < fileList.length;i++){
            size += fileList[i].file.size
        }
        setFileSizeByte(size)
        size = size / 1024 / 1024 / 1024
        setFileSizeOver(size > 300)
        setFileSize(Math.ceil(size) + " GB")

        // 獲得ポイント計算
        calcPoint(fileList.length).then(r => {
            if(r.result){
                setCalcPointInfo(r.data)
            }
        })

        if(fileList.length > 0){
            document.getElementById("load-image").src = fileList[editImageNo].useMosaic ? fileList[editImageNo].imageDataEdited : fileList[editImageNo].imageDataMiddle
            if(selectedImageFilename !== fileList[editImageNo].file.name){
                setInsideThumbnail()
                setOutsideThumbnail()
                setSelectedImageFilename(fileList[editImageNo].file.name)
            }
        }

        if(fileList.length > 0){
            let video = fileList[0]
            ImageUtil.videoLoad(fileList,video.file,0, (data,data2,data3)=>{
                if(data === false){
                    video.error = true
                    setMessageShow("block")
                    setMessage(message+"「"+video.file.name+"」が読み込めませんでした。\r\n")
                    // エラーなら削除
                    setFileList(fileList.map(f=>f).filter((video,idx)=>!video.error))
                    console.log("load1")
                } else {
                    console.log("load2")
                    document.getElementById("img"+0).src = data
                    console.log(data)
                    video.imageData = data
                    video.imageDataMiddle = data2
                    video.imageDataOriginal = data3
                    video.imageDataEdited = data3
                    if(0 === editImageNo) document.getElementById("select-img").src = data
                    //if(i === editImageNo) document.getElementById("select-img-ai").src = data2
                    //if(0 === editImageNo) setMetaDataField(fileList[editImageNo],true)
                    // サムネイル調整用の初期画像
                    if(0 === editImageNo) {
                        document.getElementById("load-image").src = fileList[editImageNo].imageDataEdited
                    }
                    if(tempThumbnail === undefined){
                        setInsideThumbnail(data3)
                    }
                }
            },setVideoLoaded)
        }
    },[fileList])

    useEffect(() => {
        if(videoLoaded){
            if(0 === editImageNo) document.getElementById("select-img").src = fileList[editImageNo].imageDataOriginal
            document.getElementById("load-image").src = fileList[editImageNo].imageDataEdited
            if(tempGroupId === undefined){
                // キーを発行する
                prepareUpload().then(r => {
                    if(r.result){
                        setTempGroupId(r.data.tempGroupId)
                    }
                })
            } else {
                uploadVideo(fileList,tempGroupId)
            }
        }
    },[videoLoaded])

    useEffect(() => {
        if(tempGroupId !== undefined) uploadVideo(fileList,tempGroupId)
    },[tempGroupId])

    // 調整用サムネイル
    const [insideThumbnail,setInsideThumbnail] = useState()   // 内部用
    const [outsideThumbnail,setOutsideThumbnail] = useState() // 外部用(OGP)
    const [tempThumbnail,setTempThumbnail] = useState()
    const [selectedImageFilename,setSelectedImageFilename] = useState()

    useEffect(() => {
        if(fileList.length > 0){
            document.getElementById("load-image").src = fileList[editImageNo].useMosaic ? fileList[editImageNo].imageDataEdited : fileList[editImageNo].imageDataMiddle
            setInsideThumbnail()
            setOutsideThumbnail()
            setSelectedImageFilename(fileList[editImageNo].file.name)
        }
    },[editImageNo])

    // 選択画像を検出してフォーム内容を切り替え
    useEffect(() => {
        if(editImageNo !== -1 && fileList.length > 0){
            setMetaDataField(fileList[editImageNo],true)
        }
    },[fileList,editImageNo])

    // 編集対象の画像を処理
    useEffect(() => {
        if(editImageTargetNo !== -1){
            let file = fileList[editImageTargetNo]
            setCanvas(file)
        }
    },[editImageTargetNo])

    function imageSet(files,isuseAIGeneration){
        setMessage('')
        setMessageShow("none")
        let fileList = []
        for(let i = 0;i < files.length;i++){
            //if(String(files[i].name).match(/\.(jpg|jpeg?|jfif|bmp|png|gif|webp)$/)){
                let img = new ImageFile({file:files[i]})
                if(isuseAIGeneration){
                    img.useAIGeneration = true
                }
                fileList.push(img)
                break
                // AI生成画像の場合は情報を取得して最初の1件目をフィールドに反映
                /*setMetaData(files[i],img).then(r => {
                    if(i === 0) setMetaDataField(img,false)
                })*/
            //}
        }
        setEditImageNo(0)
        setFileList(fileList)
    }

    function imageAdd(files,isuseAIGeneration){
        return
        setMessage('')
        setMessageShow("none")
        let list = fileList.concat([])
        for(let i = 0;i < files.length;i++){
            //if(String(files[i].name).match(/\.(jpg|jpe?|jfif|bmp|png|gif|webp)$/)){
                let img = new ImageFile({file:files[i]})
                if(isuseAIGeneration){
                    img.useAIGeneration = true
                }
                list.push(img)
                // AI生成画像の場合は情報を取得してフィールドに設定
                /*setMetaData(files[i],img).then(r => {

                })*/
            //}
        }
        setFileList(list)
    }

    /**
     * AIで作成された画像の生成情報を取得する
     * @todo 絵文字があるとextractChunksで読み込めない
     * 
     * @param {File} file 
     * @param {ImageFile} img 
     */
    function setMetaData(file,img){
        return file.arrayBuffer().then(buffer => {
            if(notReadPromptInfo) return
            try {
                let chunks = extractChunks(new Uint8Array(buffer))
                .filter(value => value.name === "tEXt")
                .map((value) => {
                    let data = value.data
                    let text = new TextDecoder().decode(data)
                    let items = ["Description","Software","Source","Comment","parameters"]
                    let itemName
                    if(undefined !== (itemName = items.find((v) => text.startsWith(v)))){
                        return {name:itemName,value:text.substring(itemName.length+1)}
                    } else {
                        return {name:itemName,value:""}
                    }
                })
                .filter(value => value.name !== undefined)
                console.log(extractChunks(new Uint8Array(buffer)))

                // Stable Diffusionならparametersがある
                let parameters = chunks.find(d => d.name === "parameters")
                if(parameters !== undefined && parameters.value !== ""){
                    img.rawInfo = parameters.value
                    let split = parameters.value.split("\n")
                    let prompt = ""
                    let negativePrompt = ""
                    let options = ""
                    let negativeIndex = 0
                    for(let i = 1;i<split.length;i++){
                        if(split[i].startsWith("Negative prompt: ")){
                            negativePrompt = split[i].replace("Negative prompt: ","")
                            negativeIndex = i
                        }
                        if(split[i].startsWith("Steps:")){
                            options = split[i]
                        }
                    }
                    for(let i = 0;i< negativeIndex;i++){
                        prompt += split[i] + "\r\n"
                    }
                    //prompt = prompt.replace(/ +/g,' ')
                    let params = []
                    for(const m of options.matchAll(/([a-zA-Z0-9 ]+): ([0-9a-zA-Z.\-_ +]+)?/g)){
                        if(m[2] !== undefined)
                        params.push({name:String(m[1]).trim(),value:m[2]})
                    }
                    // プロンプト
                    for(const m of options.matchAll(/([a-zA-Z0-9 ]+): "(.+?)"/g)){
                        if(m[2] !== undefined)
                        params.push({name:String(m[1]).trim(),value:m[2]})
                    }
                    if(split.length <= 1){
                        throw new Error("必要な情報が揃っていません。")
                    }
                    /*let params = options.split(",").map(d => {
                        let name
                        let value
                        let tmp
                        let item
                        tmp = d.trim()
                        item = tmp.split(":")
                        name = item[0]
                        value = item[1].substring(1)
                        console.log("4")
                        return {name:name,value:value}
                    })*/

                    img.prompt = prompt
                    let modelHash = params.find(d => d.name === "Model hash")
                    if(modelHash !== undefined){
                        img.software = "no-select"
                        if(modelHash.value === "6569e224"){
                            img.software = "AnythingV3"
                        } else if(
                               modelHash.value === "04c147f2" // v1.1 full
                            || modelHash.value === "4567aa0f" // v1.1
                            || modelHash.value === "11d755f8" // v1.2 full
                            || modelHash.value === "5e18682b" // v1.2
                            || modelHash.value === "ec706de4" // v1.3 full
                            || modelHash.value === "3706d7ad" // v1.3
                            || modelHash.value === "06c50424" // v1.4 full
                            || modelHash.value === "7460a6fa" // v1.4
                        ){
                            img.software = "StableDiffusion"
                        } else if(
                               modelHash.value === "84692140"   // v1.3 float16
                            || modelHash.value === "4470c325"   // v1.3 float32
                            || modelHash.value === "e1de58a9"   // v1.3 full
                            || modelHash.value === "3e1a125f"   // v1.3 full opt
                            || modelHash.value === "27310bc7"   // v1.4
                        ){
                            img.software = "WaifuDiffusion"
                        } else if(
                               modelHash.value === "e2ec4647" // 16
                            || modelHash.value === "3a0cfc1c" // 17
                        ){
                            img.software = "HentaiDiffusion"
                        } else if(
                               modelHash.value === "abaf1da6" // ACertainModel-half
                            || modelHash.value === "0ea1c8b4" // ACertainModel
                        ){
                            img.software = "ACertainModel"
                        } else if(
                            modelHash.value === "27bd26ec" // ACertainThing-half
                         || modelHash.value === "26f53cad" // ACertainThing
                        ){
                            img.software = "ACertainThing"
                        } else if(
                               modelHash.value === "0e200e66" // ACertainty
                        ){
                            img.software = "ACertainty"
                        } else if(modelHash.value === "b5c0b653"){
                            img.software = "Protogen"
                        } else if(modelHash.value === "fde2460c"){ 
                            img.software = "ourtAIDiffusion" // V1.0
                        } else if(modelHash.value === "4048130a"){
                            img.software = "Counterfeit" // V2.0
                        } else if(modelHash.value === "8838e0d1fb"){
                            img.software = "Counterfeit" // V2.0
                        } else if(modelHash.value === "f3b033b02f"){
                            img.software = "Counterfeit" // V2.0
                        } else if(modelHash.value === "71e703a0fc"){
                            img.software = "Counterfeit" // V2.5
                        } else if(modelHash.value === "fc9d6d1ff2"){
                            img.software = "SukiyakiMix" // v1.0
                        } else if(modelHash.value === "6e350084a6"){
                            img.software = "7th_anime" // 7th_anime_3.1_A
                        } else if(modelHash.value === "a916690d6d"){
                            img.software = "ourt AI Diffusion (Anime V1)" // Anime V1
                        } else if(modelHash.value === "7a5574856e"){
                            img.software = "ourt AI Diffusion (Anime V2)" // Anime V2
                        } else if(modelHash.value === "1b5f8211ec"){
                            img.software = "Aurora_v1.0" // Aurora v1.0
                        } else if(modelHash.value === "6772b99463"){
                            img.software = "blue_pencil_v9b" // blue_pencil_v9b
                        } else if(modelHash.value === "3a105af1a6"){
                            img.software = "blue_pencil_v10" // blue_pencil_v10
                        } else if(modelHash.value === "b1fce039e2"){
                            img.software = "milktea_mild_V1" // milktea_mild_V1
                        } else if(modelHash.value === "e4a30e4607"){
                            img.software = "majicmixRealistic_v6"
                        } else {
                            let model = params.find(d => d.name === "Model")
                            if(model !== undefined){
                                img.software = model.value
                            }
                            img.modelHash = modelHash.value
                        }

                        img.modelHash = modelHash.value

                    } else {
                        img.software = "no-select"
                        let model = params.find(d => d.name === "Model")
                        if(model !== undefined){
                            img.software = model.value
                        } else {
                            throw new Error("unsupported model")
                        }
                    }

                    let steps = params.find(d => d.name === "Steps")
                    let scale = params.find(d => d.name === "CFG scale")
                    let seed = params.find(d => d.name === "Seed")
                    let sampler = params.find(d => d.name === "Sampler")
                    let denoisingStrength = params.find(d => d.name === "Denoising strength")
                    let maskBlur = params.find(d => d.name === "Mask blur")
                    let clipSkip = params.find(d => d.name === "Clip skip")
                    let controlNetEnabled = params.find(d => d.name === "ControlNet Enabled")
                    let controlNetModule = params.find(d => d.name === "ControlNet Module")
                    let controlNetModel = params.find(d => d.name === "ControlNet Model")
                    let controlNetWeight = params.find(d => d.name === "ControlNet Weight")
                    let ensd = params.find(d => d.name === "ENSD")
                    let hiresUpscale = params.find(d => d.name === "Hires upscale")
                    let hiresUpscaler = params.find(d => d.name === "Hires upscaler")

                    img.comment = {
                        uc:negativePrompt,
                        noise:"",
                        steps:steps === undefined ? "" : steps.value,
                        scale:scale === undefined ? "" : scale.value,
                        seed:seed === undefined ? "" : seed.value,
                        sampler:sampler === undefined ? "" : sampler.value,
                        // img2imgの場合はDenoising strengthとMask blurも追加
                        strength:denoisingStrength === undefined ? "" : denoisingStrength.value,
                        maskBlur:maskBlur === undefined ? "" : maskBlur.value,
                        clipSkip:clipSkip === undefined ? "" : clipSkip.value,
                        controlNetEnabled:controlNetEnabled === undefined ? "" : controlNetEnabled.value,
                        controlNetModule:controlNetModule === undefined ? "" : controlNetModule.value,
                        controlNetModel:controlNetModel === undefined ? "" : controlNetModel.value,
                        controlNetWeight:controlNetWeight === undefined ? "" : controlNetWeight.value,
                        ensd:ensd === undefined ? "" : ensd.value,
                        hiresUpscale:hiresUpscale === undefined ? "" : hiresUpscale.value,
                        hiresUpscaler:hiresUpscaler === undefined ? "" : hiresUpscaler.value,
                        vae:"",
                        gpu:"",
                        vram:""
                    }
                    return
                }

                // softwareがNovelAIの場合
                let software = chunks.find(d => d.name === "Software")
                let source = chunks.find(d => d.name === "Source")
                let description = chunks.find(d => d.name === "Description")
                let comment = chunks.find(d => d.name === "Comment")

                if(source !== undefined && source.value.split(" ").length === 3){
                    img.modelHash = source.value.split(" ")[2]
                }
                if(software !== undefined && software.value === "NovelAI"){
                    img.prompt = description === undefined ? "" : description
                    img.software = software.value
                    img.useAIGeneration= false
                    img.rawInfo = ""
                    img.vae = ""
                    img.gpu = ""
                    img.vram = ""
                    if(comment !== undefined && comment.value !== ""){
                        let j = JSON.parse(comment.value)
                        img.comment = {uc:j.uc,noise:j.noise,steps:j.steps,scale:j.scale,seed:j.seed,sampler:j.sampler,strength:j.strength,maskBlur:"",
                        clipSkip:"",controlNetEnabled:"",controlNetModule:"",controlNetModel:"",controlNetWeight:"",ensd:"",hiresUpscale:"",hiresUpscaler:""}
                    }
                }
            } catch(e) {
                img.prompt = ""
                img.software = "no-select"
                img.modelHash = ""
                img.vae = ""
                img.gpu = ""
                img.vram = ""
                img.comment = {uc:"",noise:"",steps:"",scale:"",seed:"",sampler:"",strength:"",maskBlur:"",
                clipSkip:"",controlNetEnabled:"",controlNetModule:"",controlNetModel:"",controlNetWeight:"",
                ensd:"",hiresUpscale:"",hiresUpscaler:"",rawInfo:"",useAIGeneration:false}
            }
        })
    }

    /**
     * 表示中のフィールドにメタデータを反映する
     * 
     * @param {ImageFile} img 
     * @param {bool} override
     */
    function setMetaDataField(img,override){
        let aiModel = document.getElementById("ai-model")
        let modelVersion = document.getElementById("model-version")
        let prompt = document.getElementById("prompt")
        let negativePrompt = document.getElementById("negative-prompt")
        let noise = document.getElementById("noise")
        let steps = document.getElementById("steps")
        let scale = document.getElementById("scale")
        let seed = document.getElementById("seed")
        let sampler = document.getElementById("sampler")
        let strength = document.getElementById("strength")
        let maskBlur = document.getElementById("mask-blur")
        let clipSkip = document.getElementById("clip-skip")
        let controlNetEnabled = document.getElementById("controlnet-enabled")
        let controlNetModule = document.getElementById("controlnet-module")
        let controlNetModel = document.getElementById("controlnet-model")
        let controlNetWeight = document.getElementById("controlnet-weight")
        let ensd = document.getElementById("ensd")
        let hiresUpscale = document.getElementById("hires-upscale")
        let hiresUpscaler = document.getElementById("hires-upscaler")
        let rawInfo = document.getElementById("raw-info")

        if(override || (aiModel.value === "no-select" && img.software !== "")){
            aiModel.value = img.software
        }
        let versions = {
            "1D44365E":"NAI Diffusion Anime (Curated)",
            "81274D13":"NAI Diffusion Anime (Full)",
            "1D09D794":"NAI Diffusion Furry (Beta V1.3)",
            "04c147f2":"v1.1 full ema", // Stable Diffusion～
            "4567aa0f":"v1.1",          
            "11d755f8":"v1.2 full ema",
            "5e18682b":"v1.2",
            "ec706de4":"v1.3 full ema",
            "3706d7ad":"v1.3",
            "06c50424":"v1.4 full ema",
            "7460a6fa":"v1.4",          // ～Stable Diffusion
            "84692140":"v1.3 float16",  // Waifu Diffusion～
            "4470c325":"v1.3 float32",
            "e1de58a9":"v1.3 full",
            "3e1a125f":"v1.3 full opt",
            "27310bc7":"v1.4",          // ～Waifu Diffusion
            "e2ec4647":"16",            // HentaiDiffusion
            "3a0cfc1c":"17",            // HentaiDiffusion
            "abaf1da6":"half",          // ACertainModel-half
            "27bd26ec":"half",          // ACertainThing-half
            "b5c0b653":"V2.2 (Anime)",  // Protogen V2.2 (Anime)
            "fde2460c":"V1.0",          // ourtAI Diffusion V1.0
            "4048130a":"V2.0",          // Counterfeit V2.0
            "8838e0d1fb":"V2.0",        // Counterfeit V2.0
            "f3b033b02f":"V2.0",        // Counterfeit V2.0
            "71e703a0fc":"V2.5",        // Counterfeit V2.5
            "fc9d6d1ff2":"v1.0 fp16",   // SukiyakiMix v1.0
            "6e350084a6":"anime_3.1_A", // 7th_anime_3.1_A
            "a916690d6d":"Anime V1",    // ourt AI Diffusion Anime V1
            "7a5574856e":"Anime V2",    // ourt AI Diffusion Anime V2
            "1b5f8211ec":"v1.0 F16",    // Aurora v1.0
            "6772b99463":"v9b",         // blue_pencil_v9b
            "3a105af1a6":"v10",         // blue_pencil_v10
            "b1fce039e2":"V1",          // milktea_mild_V1
            "e4a30e4607":"v6"           // majicmixRealistic_v6
        }
        if(override || (modelVersion.value === "" && img.modelHash !== "")){
            if(versions[img.modelHash]){
                modelVersion.value = versions[img.modelHash]
            } else {
                modelVersion.value = ""
            }
        }
        if(override || (prompt.value === "" && img.prompt)){
            prompt.value = img.prompt
        }
        if(override || (negativePrompt.value === ""  && img.comment && img.comment.uc)){
            negativePrompt.value = img.comment.uc
        }
        if(override || (noise.value === ""  && img.comment && img.comment.noise)){
            noise.value = img.comment.noise
        }
        if(override || (steps.value === ""  && img.comment && img.comment.steps)){
            steps.value = img.comment.steps
        }
        if(override || (scale.value === ""  && img.comment && img.comment.scale)){
            scale.value = img.comment.scale
        }
        if(override || (seed.value === ""  && img.comment && img.comment.seed)){
            seed.value = img.comment.seed
        }
        if(override || (sampler.value === ""  && img.comment && img.comment.sampler)){
            sampler.value = img.comment.sampler
        }
        if(override || (strength.value === ""  && img.comment && img.comment.strength)){
            strength.value = img.comment.strength
        }
        if(override || (maskBlur.value === ""  && img.comment && img.comment.maskBlur)){
            maskBlur.value = img.comment.maskBlur
        }
        if(override || (clipSkip.value === ""  && img.comment && img.comment.clipSkip)){
            clipSkip.value = img.comment.clipSkip
        }
        if(override || (controlNetEnabled.value === ""  && img.comment && img.comment.controlNetEnabled)){
            controlNetEnabled.value = img.comment.controlNetEnabled
        }
        if(override || (controlNetModule.value === ""  && img.comment && img.comment.controlNetModule)){
            controlNetModule.value = img.comment.controlNetModule
        }
        if(override || (controlNetModel.value === ""  && img.comment && img.comment.controlNetModel)){
            controlNetModel.value = img.comment.controlNetModel
        }
        if(override || (controlNetWeight.value === ""  && img.comment && img.comment.controlNetWeight)){
            controlNetWeight.value = img.comment.controlNetWeight
        }
        if(override || (ensd.value === ""  && img.comment && img.comment.ensd)){
            ensd.value = img.comment.ensd
        }
        if(override || (hiresUpscale.value === ""  && img.comment && img.comment.hiresUpscale)){
            hiresUpscale.value = img.comment.hiresUpscale
        }
        if(override || (hiresUpscaler.value === ""  && img.comment && img.comment.hiresUpscaler)){
            hiresUpscaler.value = img.comment.hiresUpscaler
        }
        if(override || (rawInfo.value === "" && img.rawInfo)){
            rawInfo.value = img.rawInfo
        }
        if(override || img.vae){
            setVAE([img.vae])
        }
        if(override || img.gpu){
            setGPU([img.gpu])
        }
        if(override || img.vram){
            setVRAM([img.vram])
        }
    }

    // ダイアログ
    const [show, setShow] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")
    const [dialogButton,setDialogButton] = useState()
    function dialog(title,message,button){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
        setDialogButton(button)
    }

    // エラーメッセージ
    const [message, setMessage] = useState('')
    const [messageShow, setMessageShow] = useState('none')

    const [ageLimit, setAgeLimit] = useState('')
    const [sexualExpression,setSexualExpression] = useState('')
    const [styleOfPainting, setStyleOfPainting] = useState('')
    const [vae, setVAE] = useState()
    const [gpu, setGPU] = useState()
    const [vram, setVRAM] = useState()

    const nenrei = [
        { name: t("upload.image.ageLimitG"), value: '1' },
        { name: t("upload.image.ageLimitPG12"), value: '2' },
        { name: t("upload.image.ageLimitR15"), value: '3' },
        { name: t("upload.image.ageLimitR18"), value: '4' },
        { name: t("upload.image.ageLimitR18G"), value: '5' }
    ]

    const radioKoukai = [
        { name: '全体公開', value: '1' },
        { name: '限定公開', value: '2' },
        { name: '非公開', value: '3' }
    ]

    const styles = [
        { name: t("upload.image.illustration"), value: '1' },
        { name: t("upload.image.semirealism"), value: '3' },
        { name: t("upload.image.photorealistic"), value: '2' },
    ]

    const yesOrNoRadio = [
        { name: t("common.yes"), value: "1" },
        { name: t("common.no"), value: "2" },
    ]

    function sendFileList(file){
        if(fileList.length === 0){
            imageSet([file],true)
        } else {
            imageAdd([file],true)
        }
        setEditImageNo(fileList.length)
        alert("投稿一覧に追加しました。")
    }
    const [serverStatus,setServerStatus] = useState([])
    function statusCountUpdate(){
        getStatusCount().then(r =>{
            setServerStatus([])
            let aiProccessingButton = document.querySelectorAll(".ai-proccessing-button")
            let info = document.querySelectorAll(".ai-proccessing-info")
            if(!r.result){
                aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
            }
            if(r.data.status === 1 || r.data.status === 2){
                setAiProccessing(() => true)
                aiProccessingButton.forEach(e => e.setAttribute("disabled",true))
            }
            if(r.data.status === 1){
                info.forEach(e => e.innerText = " " + r.data.count + "人が待機中です。予想待機時間:"+r.data.time+"分")
                procId = r.data.procId
            } else if(r.data.status === 2) {
                info.forEach(e => e.innerText = "予想待機時間:"+r.data.time+"分")
                procId = r.data.procId
            } else if(r.data.status === 0){
                info.forEach(e => e.innerText = "")
                // 1または2のレコードがなく、現在処理中のproc_idがある場合はその後のステータスを取得する
                if(procId !== ""){
                    getStatus(procId).then(r => {
                        if(r.data.status === 3) {
                            info.forEach(e => e.innerText = " 生成完了")
                            let imageFile = base64ToFile(r.data.base64img.replace(/^.*,/, ''),procId + ".png","image/png")
                            //setReceivedImageFile(imageFile)
                            ImageUtil.load(undefined,imageFile,0,(data1,data2,base64) => {
                                dialog("",(
                                    <Container className='text-center'>
                                        <p>生成完了</p>
                                        <Image
                                            style={{cursor:"pointer",width:"256px"}}
                                            onClick={(e) => {
                                                setPreviewSource(base64)
                                                setPreviewFlg(true)
                                            }}
                                            src={data2} />
                                        <br /><br />
                                        <Button onClick={() => {
                                            sendFileList(imageFile)
                                        }}>投稿一覧に追加</Button>
                                        <Button style={{marginLeft:"10px"}} onClick={() => {
                                            setImg2ImgFile(base64)
                                            document.getElementById("img2img-thumb").src = data2
                                            alert("img2imgに追加しました。")
                                        }}>img2imgに送る</Button>
                                        <Button style={{marginLeft:"10px"}} onClick={() => {
                                            navigator.clipboard.writeText(r.data.seed)
                                            alert("seed値をクリップボードにコピーしました。")
                                        }}>{r.data.seed}</Button>
                                    </Container>
                                ))
                                //aiProccessingCall()
                            })
                            aiProccessingCall()
                            clearAllInterval()
                            setAiProccessing(() => false)
                            aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
                            procId = ""

                            // 生成履歴再取得
                            setAIGenerateReset(!aiGenerateReset)
                            setAIGenerateImagePage(1)
                        } else if(r.data.status === 4) {
                            info.forEach(e => e.innerText = " 処理失敗")
                            clearAllInterval()
                            setAiProccessing(() => false)
                            aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
                            procId = ""
                        } else if(r.data.status === 5) {
                            info.forEach(e => e.innerText = " 処理中断")
                            clearAllInterval()
                            setAiProccessing(() => false)
                            aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
                            procId = ""
                        }
                        if(r.data.status === 4 || r.data.status === 5){
                            getPoint().then(r => {
                                if(r.result){
                                    setPoint(r.point)
                                }
                            })
                        }
                    })
                }
                setServerStatus(r.data)
            }
        })
    }
    function base64ToFile(base64,filename,mime){
        let bin = atob(base64.replace(/^.*,/, ''));
        let buffer = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) {
            buffer[i] = bin.charCodeAt(i);
        }
        return new File([buffer.buffer], filename, {type: mime});
    }
    function download(blob){
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a")
        document.body.appendChild(a)
        a.download = 'foo.pdf'
        a.href = url
        a.click()
    }
    function aiProccessingCall(){
        let aiProccessingButton = document.querySelectorAll(".ai-proccessing-button")
        getPoint().then(r => {
            if(r.result){
                setPoint(r.point)
                aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
            } else {
                dialog("エラー",r.errors)
                aiProccessingButton.forEach(e => e.setAttribute("disabled",false))
            }
        })
        getStatusCount().then(r =>{
            statusCountUpdate()
            if(r.result){
                setInterval(() =>{
                    statusCountUpdate()
                },2000)
            } else {
                setAiProccessing(() => false)
                aiProccessingButton.forEach(e => e.setAttribute("disabled",false))
            }
        })
    }
    function clearAllInterval(){
        for (var i = 1; i < 99999; i++)
            window.clearInterval(i)
    }
    function setCanvas(file){
        let data = file.useMosaic === "1" ? file.imageDataEdited : file.imageDataOriginal
        let canvas = document.createElement("canvas")
        canvas.id = "canvas"
        let ctx = canvas.getContext("2d")

        let img = document.createElement("img")
        img.src = data
        img.onload = () => {
            let w = 0
            let h = 0
            if(img.naturalWidth > img.naturalHeight){
                w = window.innerWidth
                h = img.naturalHeight * (window.innerWidth / img.naturalWidth)
            } else {
                w = img.naturalWidth * ((window.innerHeight - 110) / img.naturalHeight)
                h = window.innerHeight - 110
            }
            w = img.naturalWidth
            h = img.naturalHeight
            canvas.width = w
            canvas.height = h
            //canvas.style.border = "5px solid #FFFFFF"
            canvas.style.zIndex = "5"
            canvas.style.margin = "0"
            canvas.style.padding = "0"
            canvas.onmouseup = (e) => canvasMouseUp(e)
            canvas.onmousedown = (e) => canvasMouseDown(e)
            canvas.onmousemove = (e) => canvasMouseMove(e)

            ctx.drawImage(img,0,0,img.naturalWidth,img.naturalHeight,0,0,w,h)
            document.getElementById("canvas-area").textContent = ""
            document.getElementById("canvas-area").append(canvas)

            if(file.useMosaic === "1"){
                let originalImage = document.createElement("img")
                originalImage.src = file.imageDataOriginal
                originalImage.onload = () => {
                    setOriginalImage(originalImage)
                }
            } else {
                setOriginalImage(img)
            }
            setMosaicImage()
        }
        return true
    }
    function setMosaicImage(){
        let originalImage = getOriginalImage()
        let ctx = originalImage.getContext("2d")

        let mosaicCanvas = document.getElementById("mosaic-image")
        mosaicCanvas.width = originalImage.width
        mosaicCanvas.height = originalImage.height
        let mosaicCtx = mosaicCanvas.getContext("2d")

        let imgData = ctx.getImageData(0, 0, originalImage.width, originalImage.height)
        if (imgData !== "") {
            if(getMosaicStyle() === "dot"){
                let mosaicSize = parseInt(getMosaicStrength(), 10)
                for (let y = 0; y < imgData.height; y+=mosaicSize) {
                    for (let x = 0; x < imgData.width; x+=mosaicSize) {
                        let cR = imgData.data[(y * imgData.width + x) * 4]
                        let cG = imgData.data[(y * imgData.width + x) * 4 + 1]
                        let cB = imgData.data[(y * imgData.width + x) * 4 + 2]
                        mosaicCtx.fillStyle = "rgb("+cR+","+cG+","+cB+")"
                        mosaicCtx.fillRect(x,y,x + mosaicSize,y + mosaicSize)
                    }
                }
            } else if(getMosaicStyle() === "blur"){
                let tempImg = document.createElement("canvas")
                tempImg.width = originalImage.width
                tempImg.height = originalImage.height
                let imageData = ctx.getImageData(0,0,originalImage.width,originalImage.height)
                let tempCtx = tempImg.getContext("2d")
                tempCtx.putImageData(imageData,0,0)

                mosaicCtx.filter = "blur(" + getMosaicStrength() + "px)"
                mosaicCtx.drawImage(tempImg,0,0)
            }
        }
    }
    function mosaicCanvas(){
        setImageEditFlag(1)
        let drawCanvas = document.getElementById("canvas")
        let ctx = drawCanvas.getContext("2d")

        let mosaicCanvas = document.getElementById("mosaic-image")
        let mosaicCtx = mosaicCanvas.getContext("2d")

        let mosaicImgData = mosaicCtx.getImageData(0, 0, drawCanvas.width, drawCanvas.height)
        ctx.putImageData(mosaicImgData,0, 0)
    }
    function getMosaicImage() {
        return document.getElementById("mosaic-image")
    }
    let mousePress = false
    function canvasMouseUp(e) {
        mousePress = false
    }
    function canvasMouseDown(e) {
        mousePress = true
        canvasMouseMove(e)
    }
    function setDrawFlag(flag){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.selectdrawflag = flag
    }
    function getDrawFlag(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.selectdrawflag
    }
    function setOriginalImage(img){
        let original = document.getElementById("original-image")
        original.width = img.naturalWidth
        original.height = img.naturalHeight
        let originalCtx = original.getContext("2d")
        // console.log(img.naturalWidth,img.naturalHeight)
        originalCtx.drawImage(img,0,0,img.naturalWidth,img.naturalHeight,0,0,img.naturalWidth,img.naturalHeight)
    }
    function getOriginalImage(){
        return document.getElementById("original-image")
    }
    function setMosaicSize(size){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.mosaicsize = size
    }
    function getMosaicSize(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.mosaicsize
    }
    function setMosaicStrength(strength){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.mosaicstrength = strength
    }
    function getMosaicStrength(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.mosaicstrength
    }
    function setMosaicStyle(style){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.mosaicstyle = style
    }
    function getMosaicStyle(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.mosaicstyle
    }
    function canvasMouseMove(e) {
        if(!mousePress) return
        let drawFlag = getDrawFlag()
        let mosaicSize = getMosaicSize()
        // 描画モード
        if(drawFlag === "1"){
            setImageEditFlag(1)
            let client = e.currentTarget.getBoundingClientRect()
            // console.log(e.pageY,client.top,client.y,window.scrollY)
            let x = e.pageX - client.x - window.scrollX - mosaicSize / 2
            let y = e.pageY - client.y - window.scrollY - mosaicSize / 2

            let mosaicImageCtx = getMosaicImage().getContext("2d")
            let ctx = e.currentTarget.getContext("2d")

            let imageData = mosaicImageCtx.getImageData(x,y,mosaicSize,mosaicSize)
            ctx.putImageData(imageData,x,y)
        }
        // 消しゴムモード
        if(drawFlag === "2"){
            setImageEditFlag(1)
            let client = e.currentTarget.getBoundingClientRect()
            let x = e.pageX - client.x - mosaicSize / 2
            let y = e.pageY - client.y - mosaicSize / 1

            let ctx = e.currentTarget.getContext("2d")
            ctx.drawImage(getOriginalImage(),x,y,mosaicSize,mosaicSize,x,y,mosaicSize,mosaicSize)
        }
    }
    function resetCanvas() {
        setImageEditFlag(0)
        let canvas = document.getElementById("canvas")
        let ctx = canvas.getContext("2d")
        let img = document.createElement("img")
        img.src = fileList[editImageTargetNo].imageDataOriginal
        img.onload = () => {
            ctx.drawImage(img,0,0)
        }
    }
    // 変更内容を保存
    function saveEdit() {
        fileList[editImageTargetNo].useMosaic = getImageEditFlag()
        fileList[editImageTargetNo].imageDataEdited = document.getElementById("canvas").toDataURL("image/png")
        setFileList(fileList.concat())
        setEditImageTargetNo(-1)
    }
    // 保存せず閉じる
    function closeEdit() {
        setEditImageTargetNo(-1)
    }
    function setImageEditFlag(flag){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.imageeditflag = flag
    }
    function getImageEditFlag(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.imageeditflag
    }
    let costList = [
        {width:"512",height:"512",cost:5,stepsPer:1,stepsLimit:150},
        {width:"768",height:"768",cost:10,stepsPer:2,stepsLimit:150},
        {width:"1152",height:"1152",cost:35,stepsPer:7,stepsLimit:150},
        {width:"1536",height:"1536",cost:70,stepsPer:21,stepsLimit:150},

        {width:"512",height:"768",cost:7,stepsPer:1,stepsLimit:150},
        {width:"768",height:"1152",cost:15,stepsPer:5,stepsLimit:150},
        {width:"768",height:"1536",cost:25,stepsPer:7,stepsLimit:150},
        {width:"1024",height:"1536",cost:30,stepsPer:10,stepsLimit:150},

        {width:"768",height:"512",cost:7,stepsPer:1,stepsLimit:150},
        {width:"1152",height:"768",cost:15,stepsPer:5,stepsLimit:150},
        {width:"1536",height:"768",cost:25,stepsPer:7,stepsLimit:150},
        {width:"1536",height:"1024",cost:30,stepsPer:10,stepsLimit:150},

        {width:"1280",height:"720",cost:15,stepsPer:5,stepsLimit:150},
        {width:"1600",height:"900",cost:30,stepsPer:10,stepsLimit:150},
        {width:"1920",height:"1080",cost:45,stepsPer:15,stepsLimit:150},

        {width:"720",height:"1280",cost:15,stepsPer:5,stepsLimit:150},
        {width:"900",height:"1600",cost:30,stepsPer:10,stepsLimit:150},
        {width:"1080",height:"1920",cost:45,stepsPer:15,stepsLimit:150},
    ]
    const freeList = [
        {width:"384",height:"768"},
        {width:"768",height:"384"},
        {width:"512",height:"512"},
        {width:"512",height:"768"},
        {width:"768",height:"512"},
        {width:"768",height:"768"},
        {width:"768",height:"1152"},
        {width:"1152",height:"768"},
        {width:"480",height:"270"},
        {width:"1280",height:"720"},
        {width:"270",height:"480"},
        {width:"720",height:"1280"},
    ]
    function calcCost() {
        
    }

    const [dragElm,setDragElm] = useState()
    // noと距離x,y
    const [len,setLen] = useState([-1,0,0])
    // 範囲内に存在する
    const [inRange,setInRange] = useState(false)
    // 選択中のno
    const [selectingNo,setSelectingNo] = useState(0)
    function dragStart(e,i){
        //console.log("dragStart",e)
        setDragElm("imgDrag"+i)
        //let img = document.querySelector("#imgDrag"+i)
        //console.log(img)
        if(e.type !== "touchstart"){
            let img = document.getElementById("dummy")
            e.dataTransfer.setDragImage(img,75, 75)
        }
        //e.dataTransfer.effectAllowed = "none"
    }
    // DPM Adaptiveは永遠に終わらなかった
    //let samplers = [{"name":"Euler a","aliases":["k_euler_a","k_euler_ancestral"],"options":{}},{"name":"Euler","aliases":["k_euler"],"options":{}},{"name":"LMS","aliases":["k_lms"],"options":{}},{"name":"Heun","aliases":["k_heun"],"options":{}},{"name":"DPM2","aliases":["k_dpm_2"],"options":{"discard_next_to_last_sigma":"True"}},{"name":"DPM2 a","aliases":["k_dpm_2_a"],"options":{"discard_next_to_last_sigma":"True"}},{"name":"DPM++ 2S a","aliases":["k_dpmpp_2s_a"],"options":{}},{"name":"DPM++ 2M","aliases":["k_dpmpp_2m"],"options":{}},{"name":"DPM++ SDE","aliases":["k_dpmpp_sde"],"options":{}},{"name":"DPM fast","aliases":["k_dpm_fast"],"options":{}},{"name":"DPM adaptive","aliases":["k_dpm_ad"],"options":{}},{"name":"LMS Karras","aliases":["k_lms_ka"],"options":{"scheduler":"karras"}},{"name":"DPM2 Karras","aliases":["k_dpm_2_ka"],"options":{"scheduler":"karras","discard_next_to_last_sigma":"True"}},{"name":"DPM2 a Karras","aliases":["k_dpm_2_a_ka"],"options":{"scheduler":"karras","discard_next_to_last_sigma":"True"}},{"name":"DPM++ 2S a Karras","aliases":["k_dpmpp_2s_a_ka"],"options":{"scheduler":"karras"}},{"name":"DPM++ 2M Karras","aliases":["k_dpmpp_2m_ka"],"options":{"scheduler":"karras"}},{"name":"DPM++ SDE Karras","aliases":["k_dpmpp_sde_ka"],"options":{"scheduler":"karras"}},{"name":"DDIM","aliases":[],"options":{}},{"name":"PLMS","aliases":[],"options":{}}]
    let samplers = [{"name":"Euler a","memo":"やわらかい表現、速い"},{"name":"DPM++ 2M Karras","memo":"人気"},{"name":"DPM++ SDE Karras","memo":"人気"},{"name":"DPM++ 2M SDE Karras","memo":"人気"},{"name":"DDIM","memo":"通常の表現"},{"name":"PLMS","memo":"stepsは35以上を推奨。色が強くでる"},{"name":"UniPC","memo":"速い"}]
    function textareaSizing(labelElementId,elementId){
        let labelElement = document.querySelector(labelElementId)
        labelElement.style.lineHeight = "20px"
        let lineHeight = labelElement.style.lineHeight.replace(/[^0-9.]+/,'')
        let n = labelElement.value.match(/\n/g)
        if(n === null){
            n = 1
        } else {
            n = n.length + 1
        }
        if(n <= 5){
            n = 5
        }
        labelElement.style.height = lineHeight * n + 30 + "px"
        document.querySelector(elementId).style.height = lineHeight * n + 30 + "px"
    }

    // キャンバスのリサイズ
    const [canvasAreaHeight,setCanvasAreaHeight] = useState(window.innerHeight - 100)
    window.onresize = function () {
        setCanvasAreaHeight(window.innerHeight - 100)
    }
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [showCropper,setShowCropper] = useState()
    const [cropTarget,setCropTarget] = useState()
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
            let image = document.getElementById("load-image")
            let canvas = document.createElement("canvas")
            let ctx = canvas.getContext("2d")
            canvas.width = image.width
            canvas.height = image.height

            ctx.drawImage(image,0,0)

            const data = ctx.getImageData(croppedAreaPixels.x,croppedAreaPixels.y,croppedAreaPixels.width,croppedAreaPixels.height)

            canvas.width = croppedAreaPixels.width
            canvas.height = croppedAreaPixels.height

            ctx.putImageData(data,0,0)

            let thumb = canvas.toDataURL("image/png")

            setTempThumbnail(thumb)
      }, [])
    const [showQuestionnairePopup,setShowQuestionnairePopup] = useState(false)
    const [questionInfo,setQuestionInfo] = useState()
    document.onpaste = function(pasteEvent) {
        let item = pasteEvent.clipboardData.items[0];
     
        if (item.type.indexOf("image") === 0){
            let file = item.getAsFile();
            if(fileList.length === 0){
                imageSet([file])
            } else {
                imageAdd([file])
            }
        }
    }
    // シリーズ
    const [seriesList,setSeriesList] = useState([])
    const [series,setSeries] = useState("")

    function displayAIGenerateInfo(){
        dialog("AI生成機能の説明",<div>
            AI生成機能ではプロンプトという文字列を入力して、画像を生成することができます。<br />
            無料で利用することができますが、生成にはポイントを使用し、ポイントは、
            活動実績に伴い翌日の基準ポイントが判定され、保有ポイントがその基準以下の場合に基準まで回復します。<br />
            この基準の判定と回復には、SMS認証をしている必要があります。<br />
            SMS認証は「設定」→「セキュリティ」タグから行えます<br />
            ※基本無料であるため、複数アカウントを作成し不正にポイントを消費することへの対策となりますのでご了承ください。<br /><br />
            また、これ以外にも「いいね」やコメント、画像を投稿することでポイントが少し付与されます。<br /><br />
            <Link to={"/legal"}>無制限プラン</Link>に加入している場合はSMS認証、ポイント不要でAI生成機能を利用できます。<br />
            <Link to={"/legal"}>認証プラン</Link>に加入している場合はポイントを消費しますが、SMS認証不要でAI生成機能を利用できます。<br />
            不明点は<a href="https://discord.gg/vQNvaCXYvu">Discord</a>よりお問い合わせください。<br />
            <hr />
            ■ポイント回復基準<br />
            SMS認証を行っていること。<br />
            <br />
            例：投稿数100 いいね数200<br />
            <br />
            条件1<br />
            ■前提<br />
            ・総利用ポイント2000毎に1枚の投稿があること。<br />
            ・1投稿に対して平均1いいね以上<br />
            <br />
            ■計算方法<br />
            　① 300 * 投稿数の平均いいね数(300以上の場合は300)<br />
            　　例：300 * 2 = 2000 → 600<br />
            　② 投稿数が30枚以上の場合はさらに300 * 投稿数の平均いいね数<br />
            　　例：300 * 2 = 600<br />
            <b>　③ ①+②の900ポイントからポイント運用で保有している口数の評価額を差し引いたものが基準ポイント<br />
            　　例：900 - (100/口 * 5口保有) = 400(100未満の場合は100ポイント)<br />
            　　※保有ポイント未満となった場合は現在の保有ポイント+100が基準ポイント</b>
            <br /><br />
            条件1の前提を満たさない場合100ポイント<br />
            ※条件は定期的に見直されます。<br />
            ➡総利用ポイント、翌日の基準ポイントは「マイページ」→「実績」から確認できます。<br />
            <hr />
            ・他の生成サービスの紹介<br />
            <a href="https://www.bing.com/create">(無料) Microsoft Image Creator</a><br />
            <a href="https://discord.gg/s49mASQHkE">(完全無料) 動物園(Discord内bot)</a><br />
            <a href="https://aiart-navi.com/aiart-ai/">(一部無料) えいあーとAI</a><br />
            <a href="https://holara.ai/" target={"_blank"} rel="noreferrer">(一部無料) Holara</a><br />
            <a href="https://novelai.net/" target={"_blank"} rel="noreferrer">(有料) NovelAI</a><br />
            <a href="https://note.com/ai_nios/n/n0826a33edc8a"  target={"_blank"} rel="noreferrer">(有料) Google Colabで画像生成AIの色々なモデルを簡単に使おう</a>
        </div>)
    }

    // AI生成機能の時間帯別利用件数
    const [userList,setUserList] = useState([])

    function createGraphData(r,title){
        const graphData = {
            labels: 
                // 軸ラベル
                // 各ラベルを配列にすることで軸ラベルが改行されて表示される
                r.map(d => [d.ymdh+"時"])
            ,
            datasets: [
                // 表示するデータセット
                {
                    data: r.map(d => d.count),
                    label: title
                },
            ],
        }
        return graphData
    }

    const [tagSelected,setTagSelected] = useState([])

    function generateHandler(e,booking){
        let jpPrompt = document.getElementById("sd-jp-prompt").value
        let prompt = document.getElementById("sd-prompt").value
        let negativePrompt = document.getElementById("sd-negative-prompt").value
        let steps = document.getElementById("sd-steps").value
        let seed = document.getElementById("sd-seed").value
        let aiResolution = sdResolution
        let res = aiResolution.split("x")
        let width = res[0]
        let height = res[1].replace(/h/,"")
        let hires = res[1].indexOf("h") !== -1
        if(tagSelected.length === 0 && prompt.trim().length === 0 && !styleSelected.find(d => d.prompt.length > 0) && enterJpPrompt && jpPrompt.length === 0){
            dialog("エラー","プロンプトを入力してください。")
            return
        }
        for(let i = 0;i < costList.length;i++){
            if(costList[i].width === width && costList[i].height === height){
                if(parseInt(steps) > costList[i].stepsLimit){
                    dialog("エラー",aiResolution + "の場合、stepsは最大" + costList[i].stepsLimit + "までにしてください。")
                    return
                }
            }
        }
        if(seed.length > 19){
            dialog("エラー","seedは最大19桁までにしてください。")
            return  
        }
        
        if(sdSampler === "DDIM" || sdSampler === "PLMS"){
            if(prompt.indexOf("AND") !== -1 || negativePrompt.indexOf("AND") !== -1){
                dialog("エラー","SamplerがDDIM/PLMSの場合はAND構文がサポートされていません。")
                return
            }
        }
        // プロンプトを記憶
        localStorage.removeItem("prompt")
        localStorage.removeItem("negativePrompt")
        localStorage.setItem("prompt",prompt)
        localStorage.setItem("negativePrompt",negativePrompt)
        prompt = prompt.replace(/{/g,"(")
        prompt = prompt.replace(/}/g,")")
        negativePrompt = negativePrompt.replace(/{/g,"(")
        negativePrompt = negativePrompt.replace(/}/g,")")

        prompt += (prompt.slice(-1) === "," ? "" : ",") + styleSelected.map(d => d.prompt.length > 0 ? (d.prompt.slice(-1) === "," ? d.prompt : d.prompt + ",") : "")
        negativePrompt += (negativePrompt.slice(-1) === "," ? "" : ",") + styleSelected.map(d => d.negative_prompt.length > 0 ? (d.negative_prompt.slice(-1) === "," ? d.negative_prompt : d.negative_prompt + ",") : "")

        if(qualityTags){
            prompt = "((masterpiece, best quality, absurdres))," + prompt
            //negativePrompt = "EasyNegative, extra fingers,fewer fingers," + negativePrompt
            //negativePrompt = "nsfw, lowres, bad anatomy, bad hands, text, error, missing fingers, extra digit, fewer digits, cropped, worst quality, low quality, normal quality, jpeg artifacts, signature, watermark, username,inaccurate limb," + negativePrompt
            //negativePrompt = "(KHFB, AuroraNegative),(worst quality, low quality:1.4),(monochrome:1.1)," + negativePrompt // 7th_test
            negativePrompt = "(worst quality, bad quality, low quality:1.4),(extra fingers, deformed hands, polydactyl:1.5), (monochrome:1.1)," + negativePrompt // blue_pencil-v9b
        }
        if(tagSelected.length > 0){
            prompt = tagSelected.map(d => d.value).join(", ") + ", " + prompt
        }
        clearAllInterval()
        statusCountUpdate(true)
        aiProccessingCall()
        let styleP = styleSelected.map(d => d.prompt.length > 0 ? (d.prompt.slice(-1) === "," ? d.prompt : d.prompt + ",") : "")
        let styleNP = styleSelected.map(d => d.negative_prompt.length > 0 ? (d.negative_prompt.slice(-1) === "," ? d.negative_prompt : d.negative_prompt + ",") : "")
        if(generateMode === "txt2img"){
            txt2img(booking,sdStyle,enterJpPrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sdSampler,sdSteps,sdScale,sdDenoisingStrength,sdSeed,width,height,hires)
        } else if(generateMode === "img2img"){
            img2img(booking,sdStyle,img2ImgFile,enterJpPrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sdSampler,sdSteps,sdScale,sdDenoisingStrength,sdSeed,width,height)
        }
        document.querySelectorAll(".ai-proccesing-button").forEach(e => e.setAttribute("disabled",true))
    }
    function aiGenInitHandler(isCallHome){
        let aiGenCloseButton = document.querySelector("#aiGenCloseButton")
        if(loginInfo.result === false){
            dialog(t("common.info"),<RegistOrLogin dialog={dialog} />)
            return
        }
        if(loginInfo.sms_auth === 0 && !loginInfo.pre_auth){
            displayAIGenerateInfo()
        }
        if(!isCallHome) setUseAiGenerate(!useAiGenerate)
        calcCost()
        if(!useAiGenerate || isCallHome){
            // スタイルを取得する
            getStyleList().then(r => {
                if(r.result){
                    setStyleOptions(r.data)
                }
            })
            aiProccessingCall()
            setAIGenerateImagePage(1)
            aiGenCloseButton.innerText = t("upload.image.closeAIGenerationPanel")
            // プロンプトを復元する
            let jpPrompt = document.getElementById("sd-jp-prompt")
            let prompt = document.getElementById("sd-prompt")
            let negativePrompt = document.getElementById("sd-negative-prompt")
            let jpP = localStorage.getItem("jpPrompt")
            let p = localStorage.getItem("prompt")
            let np = localStorage.getItem("negativePrompt")
            if(jpPrompt.value.length === 0 && jpP !== null){
                jpPrompt.value = jpP
            }
            if(prompt.value.length === 0 && p !== null){
                prompt.value = p
            }
            if(negativePrompt.value.length === 0 && np !== null){
                negativePrompt.value = np
            }
            // プロンプトエリアの幅調整
            textareaSizing("#sd-jp-prompt",".sd-jp-prompt-textarea")
            textareaSizing("#sd-prompt",".sd-prompt-textarea")
            textareaSizing("#sd-negative-prompt",".sd-negative-prompt-textarea")
        } else {
            clearAllInterval()
            setAiProccessing(false)
            aiGenCloseButton.innerText = t("upload.image.AIGeneration")
        }
    }
    function uploadHandler(e){
        let title = document.getElementById("title")
        let description = document.getElementById("description")
        let deletePassword = document.getElementById("delete-password")
        let batch = document.getElementById("batch").checked
        if(!batch && title.value.trim().length === 0 ){
            dialog("エラー","タイトルを入力して下さい。")
            return false
        }
        if(styleOfPainting.length === 0 ){
            dialog("エラー","画風を選択してください。")
            return false
        }
        /*if(description.value.trim().length === 0){
            dialog("エラー","概要を入力して下さい。")
            return false
        }*/
        if(bookingDate !== "" && bookingTime === ""){
            dialog("確認","予約投稿を行う場合は時分も入力してください。")
            return false
        }
        if(bookingDate === "" && bookingTime !== ""){
            dialog("確認","予約投稿を行う場合は年月日も入力してください。")
            return false
        }
        if(ageLimit === ""){
            dialog("エラー","年齢制限を指定して下さい。")
            return false
        }
        // 全年齢の場合、性的表現について必須
        if(ageLimit === "1"){
            if(sexualExpression === ""){
                dialog("エラー","性的表現を指定して下さい。")
                return false
            }
        } else {
            if(sexualExpression !== ""){
                dialog("エラー","性的表現の指定は不要です。")
                return false
            }
        }
        let aiModel = document.getElementById("ai-model")
        let prompt = document.getElementById("prompt")
        let negativePrompt = document.getElementById("negative-prompt")
        let request = document.getElementById("request")
        for(let i = 0;i < fileList.length;i++){
            /*if(fileList[i].software === "" || fileList[i].software === "no-select"){
                dialog("エラー",<Container>使用したモデルを入力してください。</Container>)
                return false
            }*/
        }
        if(prompt.value.trim().length > 50000){
            dialog("エラー","生成テキスト、プロンプトの上限は50,000文字です。")
            return false
        }
        if(negativePrompt.value.trim().length > 50000){
            dialog("エラー","ネガティブプロンプトの上限は50,000文字です。")
            return false
        }
        if(request.value.trim().length > 50000){
            dialog("エラー","機能追加要望等の上限は50,000文字です。")
            return false
        }
        if(loginInfo.length === 0){
            if(deletePassword.value.trim().length === 0 && loginInfo.length === 0){
                dialog("エラー","削除パスワードを入力して下さい。")
                return false
            }
        }
        // ファイルサイズチェック
        /*let fileSize = 0
        for(let i = 0;i < fileList.length;i++){
            fileSize += fileList[i].file.size
        }
        // 104857600 100MB
        // 262144000 200MB
        // 107374182400 100GB
        if(fileSize > 31457280000){
            dialog("エラー","ファイルサイズの合計は30GBです。")
            return
        }
        if(fileList.length === 0){
            dialog("エラー","ファイルを選択して下さい。")
            return false
        }*/
        // ファイル数チェック
        /*if(fileList.length > 300){
            dialog("エラー","一度にアップロードできるのは300ファイルまでです。")
            return false
        }*/
        /*if(insideThumbnail === undefined){
            dialog("エラー","サムネイルを設定してください。")
            return false
        }
        if(outsideThumbnail === undefined){
            dialog("エラー","外部サイト向けサムネイルを設定してください。")
            return false
        }*/
        if(questionInfo !== undefined){
            if((questionInfo.deadlineDate.length === 0 && questionInfo.deadlineTime.length > 0)
                || (questionInfo.deadlineDate.length > 0 && questionInfo.deadlineTime.length === 0)){
                dialog(t("common.error"),"投票を作成する場合は日付と時間を両方指定してください。")
                return false
            }
        }
        //isLoggin().then(r=>{
        //    if(r){
                uploadSelect(fileList)
        //    } else {
        //        dialog("エラー","投稿するにはログインしてください。")
                // トップへ戻る
                //document.getElementById("logo").click();
        //    }
        //})
    }
    return (
    <>
    <div style={{display:editImageTargetNo !== -1 ? "block" : "none",position:"fixed",top:0,width:"100%",height:"100%",background:"#000000",zIndex:4,opacity:"0.9"}}>
    </div>
    <div id="paint-tools" style={{display:editImageTargetNo !== -1 ? "block" : "none",position:"fixed",top:0,color:"#FFFFFF",margin:"0 auto",zIndex:4,width:"100%"}} className="text-center">
        <div style={{width:"100%"}} className="d-flex justify-content-center">
            <p style={{display:"block"}}>モザイクのスタイル：</p>
            <Form.Select id="mosaic-size" className="mb-1" style={{display:"block",width:"100px"}}
                onChange={(e) => {
                    setMosaicStyle(e.currentTarget.value)
                    setMosaicImage()
                }}>
                <option value="dot">ドット</option>
                <option value="blur">ぼかし</option>
            </Form.Select>
            <p style={{display:"block"}}>モザイクの大きさ：</p>
            <Form.Select id="mosaic-size" className="mb-1" style={{display:"block",width:"100px"}}
                onChange={(e) => {
                    setMosaicSize(e.currentTarget.value)
                }} defaultValue={30}>
                {[...Array(30)].map((v,i) => {
                    return <option value={(i+1)*2} key={i}>{(i+1)*2}px</option>
                })}
            </Form.Select>
            <p style={{display:"block"}}>モザイク強度：</p>
            <Form.Control type="number" id="mosaic-strength" min={1} className="mb-1" style={{display:"block",width:"100px"}}
                onChange={(e) => {
                    setMosaicStrength(e.currentTarget.value)
                    setMosaicImage()
                }} defaultValue={20}>
            </Form.Control>
        </div>
        <Button variant={editLabel === "mosaic" ? 'light' : "primary"} onClick={() => {
            setDrawFlag(1)
            setEditLabel("mosaic")
        }}><Icon.BrushFill /></Button>
        <Button variant={editLabel === "eraser" ? 'light' : "primary"} style={{marginLeft:"3px"}} onClick={() => {
            setDrawFlag(2)
            setEditLabel("eraser")
        }}><Icon.EraserFill /></Button>
        <Button variant='primary' style={{marginLeft:"3px"}} onClick={() => {
            mosaicCanvas()
        }}>全体をモザイク</Button>
        <Button variant='success' style={{marginLeft:"3px"}} onClick={() => {
            saveEdit()
        }}>OK</Button>
        <Button variant='danger' style={{marginLeft:"3px"}} onClick={() => {
            resetCanvas()
        }}>Reset</Button>
        <Button variant='danger' style={{marginLeft:"3px"}} onClick={() => {
            closeEdit()
        }}>Close</Button>
        <br />
        <canvas id="tempCanvas" style={{display:"none"}} />
        <div id="canvas-area" className="m-0 p-0" data-selectdrawflag={1} data-mosaicsize={30} data-mosaicstrength={20} data-imageeditflag={0} data-mosaicstyle={"dot"} 
            style={{width:"auto",height:canvasAreaHeight,overflow:"auto"}}
        />
        <canvas id="original-image" style={{display:"none"}} />
        <canvas id="mosaic-image" style={{display:"none"}} />
    </div>
    <div className="wrapper">
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        <div style={{margin:"0 auto",width:"360px",boxSizing:"border-box",position:"fixed",zIndex:"1",top:(window.innerHeight - 500) / 2,left:(window.innerWidth - 360) / 2,display:postedGroupId !== "" ? "block" : "none"}}>
            <Alert style={{position:"absolute"}}>
                <CloseButton style={{position:"absolute",right:"20px"}} onClick={() => {
                    setPostedGroupId("")
                    setURL("")
                    setImgURL("")
                }}/>
                <p>投稿しました。<br />公開できる状態になるまで暫くお待ちください。<br />
                   ※新着には公開できる状態になった後、10分程で反映されます。<br />
                   </p>
                <p className='d-none'><a href={url} target="_blank" rel="noreferrer" style={{textDecoration:"none",padding:"8px 14px",borderRadius:"20px",backgroundColor:"#1D9BF0",color:"#FFFFFF",border:"1px solid #1D9BF0"}}><Icon.Twitter /> Tweet</a></p>
                <div style={{width:"360px",height:"360px"}}>
                    <Link to={"/video/"+postedGroupId}><Image src={imgUrl} style={{objectFit:"cover",width:"100%",height:"100%",borderRadius:"20px"}} /></Link>
                </div>
            </Alert>
        </div>
        <Container style={{display:postedGroupId !== "" ? "none" : "block"}}>
            <Tabs defaultActiveKey="video" className="mt-3"
            onSelect={(s) => {if(s !== "audio") navigate("/upload/"+s)}}>
                <Tab eventKey="model" title={<><Icon.Magic /> {t("common.model")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/model")}></Tab>
                <Tab eventKey="character" title={<><Icon.Person /> {t("upload.character.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/character")}></Tab>
                <Tab eventKey="image" title={<><Icon.Image /> {t("upload.image.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/image")}></Tab>
                <Tab eventKey="video" title={<><Icon.FileText /> {t("upload.video.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/video")}></Tab>
                <Tab eventKey="text" title={<><Icon.FileText /> {t("upload.text.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/text")}></Tab>
                <Tab eventKey="audio" title={<><Icon.VolumeUp /> {t("upload.audio.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/audio")}>
                    準備中・・・
                </Tab>
                <Tab eventKey="event" title={<><Icon.Shop /> {t("upload.event.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/event")}></Tab>
            </Tabs>
            {false && odai ? <Link to={"/odai"} className='d-none d-md-block'><Alert variant='warning'>今日のお題「{odai}」</Alert></Link> : ""}
                    <pre style={{backgroundColor:"#555555",color:"#FFFFFF",padding:"10px",borderRadius:"5px",display:messageShow}}>{message}</pre>
                    <Accordion flush style={{border:"1px solid #CCCCCC"}} className="mb-3 d-none">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><Icon.LightbulbFill style={{color:"orange"}} />&nbsp;{t("upload.image.stepsToSubmission")}</Accordion.Header>
                                <Accordion.Body>
                                <ul style={{listStyle:"none"}} className="p-0">
                                    <li>{t("upload.image.step1-1")}<br />　{t("upload.image.step1-2")}</li>
                                    <li>{t("upload.image.step2")}</li>
                                    <li>{t("upload.image.step3")}</li>
                                    <li>{t("upload.image.step4")}</li>
                                </ul>
                                <strong>{t("upload.image.before")}</strong><br />
                                <a href="https://cgworld.jp/article/cgw293-t1-aiqa.html" target="_blank" rel="noreferrer">➡データ・AI法務の専門家・柿沼太一弁護士に聞く！ AI関連著作権法Q&A</a>
                                </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                    <h3>①{t("upload.video.select")}</h3>
                    <div style={{display:"none"}}>
                        <InputGroup className="mb-3" style={{maxWidth:"450px"}}>
                            <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={notReadPromptInfo} id="read-prompt-info" onChange={(e) => {
                                setNotReadPromptInfo(e.currentTarget.checked)
                            }} />
                            <Form.Control type="text" value={t("upload.image.fileSelectReadPrompt")} readOnly />
                        </InputGroup>
                    </div>
                    <Container className="d-block mb-3" style={{border:"3px solid #000000",borderRadius:"5px",width:fileList.length > 0 ? "240px" : "auto",height:"220px",cursor:"pointer"}} id="upload-area"
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => {
                            e.preventDefault()
                            if(fileList.length === 0){
                                imageSet(e.dataTransfer.files)
                            } else {
                                if(dragElm === undefined){
                                    imageAdd(e.dataTransfer.files)
                                }
                            }
                        }}
                        //onDragEnd={() => setDragElm()}
                        onClick={(e) => {
                            e.stopPropagation()
                            if(fileList.length === 0){
                                document.getElementById("file").click()
                            } else {
                                document.getElementById("file_add").click()
                            }
                        }}
                        >
                        {fileList.map((imgFile,i) => {
                            console.log(imgFile)
                            if(imgFile.imageData !== undefined){
                                document.getElementById("img" + i).src = imgFile.imageData
                            } else {
                                /*ImageUtil.videoLoad(fileList,imgFile.file,i,(data,data2,data3)=>{
                                    if(data === false){
                                        imgFile.error = true
                                        setMessageShow("block")
                                        setMessage(message+"「"+imgFile.file.name+"」が読み込めませんでした。\r\n")
                                        // エラーなら削除
                                        setFileList(fileList.map(f=>f).filter((imgFile,idx)=>!imgFile.error))
                                    } else {
                                        document.getElementById("img"+i).src = data
                                        imgFile.imageData = data
                                        imgFile.imageDataMiddle = data2
                                        imgFile.imageDataOriginal = data3
                                        imgFile.imageDataEdited = data3
                                        //if(i === editImageNo) document.getElementById("select-img").src = data
                                        //if(i === editImageNo) document.getElementById("select-img-ai").src = data2
//                                        if(i === editImageNo) setMetaDataField(fileList[editImageNo],true)
                                        // サムネイル調整用の初期画像
                                        if(i === editImageNo) {
                                            document.getElementById("load-image").src = fileList[editImageNo].imageDataEdited
                                        }
                                    }
                                })*/
                            }
                            return (
                                <div className="m-1" style={{width:"200px",height:"150px",position:"relative"}} key={i} data-no={i} id={"imgDiv"+i}>
                                    <div style={{width:"200px",height:"150px",position:"relative",backgroundColor:"#FFFFFF",
                                    marginLeft:inRange && len[0] === i ? (len[0] > selectingNo ? "-50px" : "50px") : "0px"}} id={"imgDrag"+i} data-no={i}>
                                        <Image className="upload-thumb" alt={imgFile.file.name} id={"img"+i} style={{objectFit:"contain",position:"absolute",width:"100%",height:"100%",cursor:"grab",
                                            border:editImageNo === i ? "6px solid orange" : "none"}} onClick={(e) => {
                                            e.stopPropagation()
                                            setEditImageNo(i)
                                        }}
                                        onDrag={(e) => {
                                            e.preventDefault()
                                        }}
                                        onDragEnd={(e) => {
                                            e.preventDefault()
                                        }}
                                        />
                                        <CloseButton style={{position:"absolute",right:"10px",top:"10px",borderRadius:"20px",backgroundColor:"#FFFFFF"}} onClick={(e) => {
                                            e.stopPropagation()
                                            // リストから画像削除
                                            setFileList(fileList.map(f=>f).filter((file,idx)=>i!==idx))
                                            //if(fileList.length === 1) deleteFormValue() 削除されるのが面倒らしい
                                            if(editImageNo !== 0 && editImageNo >= i) setEditImageNo(editImageNo - 1)
                                            setVideoLoaded(false)
                                            setTempGroupId()
                                        }} title="閉じる" />
                                        <Container style={{position:"absolute",bottom:"0",width:"100%",backgroundColor:"rgba(0,0,0,0.5)",color:"#FFFFFF",overflow:"hidden",whiteSpace:"nowrap"}}>{imgFile.file.name}</Container>
                                    </div>
                                </div>
                            )
                        })}
                        {/*<Image id="dummy" src="/img/dot.png" style={{display:fileList.length > 0 ? "inline" : "none"}} />*/}
                        {fileList.length === 0 ? (
                        <Container className="text-center p-3" style={{clear:"both",fontSize:"18px"}}>
                            <Icon.Upload style={{fontSize:"64px"}}/><br />
                            {t("upload.image.fileDragAndDrop")}<br />
                            mp4形式,5分以内<br />
                            <Button className='m-1'>{t("upload.image.selectFile")}</Button>
                            <Button className='m-1 d-none' variant='outline-secondary'
                                style={{display:loginInfo.result !== undefined && loginInfo.result ? "inline" : "none",marginRight:"10px"}}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    if(displayAIGeneratedPanel){
                                        setAIGenerateImageList([])
                                        setAIGenerateImagePage(-1)
                                        setDisplayAIGeneratedPanel(false)
                                    } else {
                                        setAIGenerateImagePage(1)
                                        setDisplayAIGeneratedPanel(true)
                                    }
                            }}>{t("upload.image.selectByGeneratedHistory")}</Button>
                        </Container>
                        ) : (
                            <div style={{width:"100%"}} className="mt-2">
                                {uploading && (<><ProgressBar id="progress" animated now={progressNow} label={`${progressLabel}`} style={{marginBottom:"10px"}} /></>)}
                                {uploading && batchUploading && (<><ProgressBar id="batch_progress" animated now={batchProgressNow} label={`${batchProgressLabel}`} style={{marginBottom:"10px"}} /></>)}
                            </div>
                        )}
                    </Container>
                    <p className='d-none'><Icon.PencilFill style={{color:"#0000FF"}} /> マーククリックでモザイク編集できます。</p>
                    <Container id="crop-area"></Container>
                    {showCropper ? (
                        <Container>
                    <Cropper
                        classes={{containerClassName: "cropper-container"}}
                        image={fileList.length > 0 && fileList[editImageNo].imageDataEdited}
                        crop={crop}
                        zoom={zoom}
                        aspect={cropTarget === "outside" ? 2 / 1 : 1 / 1}
                        onCropChange={setCrop}
                        onCropComplete={onCropComplete}
                        onZoomChange={setZoom}

                    />
                        <Container style={{position:"absolute",width:"300px",height:"110px",zIndex:3,left:window.innerWidth / 2 - 150,bottom:"120px",borderRadius:"10px",backgroundColor:"#EEEEEE"}} className="p-3">
                            <FloatingLabel controlId="crop-zoom" label="" className="mb-3"
                                style={{position:"absolute",zIndex:3,top:0,width:"90%",fontSize:"24px"}}
                            >
                                <Form.Range type="range" defaultValue={zoom} min={1} max={5} step={0.1} onChange={(e) => {
                                    setZoom(e.currentTarget.value)
                                }} />
                            </FloatingLabel>
                            <Button style={{position:"absolute",zIndex:3,left:"30px",bottom:"10px",fontSize:"24px"}} onClick={() => {
                                if(cropTarget === "inside"){
                                    setInsideThumbnail(tempThumbnail)
                                } else {
                                    setOutsideThumbnail(tempThumbnail)
                                }
                                setShowCropper(false)
                                
                            }}>OK</Button>
                            <Button variant='secondary' style={{position:"absolute",zIndex:3,right:"30px",bottom:"10px",fontSize:"24px"}} onClick={() => {
                                setShowCropper(false)
                            }}>Cancel</Button>
                            </Container>
                        </Container>
                    ) : ""}
                    <Container className='flex-wrap justify-content-center' style={{display:fileList.length > 0 ? "flex" : "none"}}>
                        <Container style={{border:"3px solid #000000",borderRadius:"5px",width:"250px",cursor:"pointer"}} className="p-2 text-center"
                            onClick={() => {
                                setShowCropper(true)
                                setCropTarget("inside")
                            }}
                        >

                            {t("common.thumbnail")} <Button variant='secondary'>{t("common.edit")}</Button><br />
                            <Container style={{width:"200px",height:"200px"}} className="p-0 mt-2">
                                {insideThumbnail === undefined ?
                                (<div style={{width:"200px",height:"200px",border:"1px solid #000000",paddingTop:"80px"}} >1:1</div>) : (
                                <Image id="crop-target-image" src={insideThumbnail} style={{objectFit:"cover",width:"100%",height:"100%",borderRadius:"10px"}} className="" />
                                )}
                            </Container>
                        </Container>
                        <Container style={{border:"3px solid #000000",borderRadius:"5px",width:"380px",height:"250px",cursor:"pointer"}} className="mt-3 p-2 text-center"
                            onClick={() => {
                                setShowCropper(true)
                                setCropTarget("outside")
                            }}
                        >
                            {t("common.thumbnailsForOutside")} <Button variant='secondary'>{t("common.edit")}</Button><br />
                            <Container style={{width:"360px",height:"180px"}} className="p-0 mt-2">
                                {outsideThumbnail === undefined ?
                                (<div style={{width:"360px",height:"180px",border:"1px solid #000000",paddingTop:"60px"}}>2:1</div>) : (
                                <Image id="crop-target-image-outside" src={outsideThumbnail} style={{objectFit:"cover",width:"100%",height:"100%",borderRadius:"10px"}} className="" />
                                )}
                            </Container>
                        </Container>
                    </Container>
                    {/* 読み込み用 */}
                    <Image id="load-image" className="d-none" />
                    {previewFlg ? (
                    <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",zIndex:9999,cursor:"pointer"}} onClick={() => setPreviewFlg(false) }>
                        <div style={{position:"fixed",top:0,left:0,backgroundColor:"#000000",width:"100%",height:"100%",opacity:0.9}} />
                        <Image
                            src={previewSource}
                            id="preview"
                            style={{position:"fixed",objectFit:"contain",width:"100%",height:"100%"}}
                        />
                    </div>
                    ) : ""}
                    <Container style={{clear: "both"}} />
                    <Form style={{position:"relative"}}>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={8} xxl={12} style={{display:fileList.length > 0 ? "block" : "none",margin:"0 auto",width:"100%"}}>
                            <Container className='d-none'>
                                {t("upload.image.fileCount")}：<span style={{color:fileList.length > 300 ? "#FF0000" : "#000000",fontWeight:fileList.length > 300 ? "bold" : "normal"}}>{fileList.length}</span> / 300 File(s)
                                <ProgressBar id="file-select-progress" animated now={Math.floor((fileList.length / 300) * 100)} label={`${Math.floor((fileList.length / 300) * 100)}%`} style={{marginBottom:"10px"}} />
                                {t("upload.image.fileSize")}：<span style={{color:fileSizeOver ? "#FF0000" : "#000000",fontWeight:fileSizeOver ? "bold" : "normal"}}>{fileSize}</span> / 30 GB
                                <ProgressBar id="filesize-progress" animated now={Math.floor(fileSizeByte / maxFileSize * 100)} label={`${Math.floor(fileSizeByte / maxFileSize * 100)}%`} style={{marginBottom:"10px"}} />
                            </Container>
                            {/*<p>拡張子：jpg、png、gif、webp</p>*/}
                            {/* .jpg,.jpe,.jpeg,.jfif,.png,.gif,.webp,.bmp */}
                            <Form.Control type="file" encType="multipart/form-data" accept="*.*" className='d-none' id="file" onChange={(e) => {
                                imageSet(e.currentTarget.files)
                                e.currentTarget.value = ""
                            }} />
                            <Form.Control type="file" encType="multipart/form-data" accept="*.*" className='d-none' id="file_add" onChange={(e) => {
                                imageAdd(e.currentTarget.files)
                                e.currentTarget.value = ""
                            }} />
                        </Col>
                        <hr />
                    </Row>
                    <Row className={uploadCompleted ? "d-block" : "d-none"}>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            <h3>②{t("upload.image.info")}</h3>
                            <div style={{display:"block"}}>
                                <InputGroup className="mb-3" style={{maxWidth:"360px"}}>
                                    <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={promptInfoPublication} id="prompt-info-publication" onChange={(e) => {
                                        setPromptInfoPublication(e.currentTarget.checked)
                                    }} />
                                    <Form.Control type="text" value={t("upload.image.public")} readOnly />
                                </InputGroup>
                            </div>
                        </Col>
                        <Col xs={6} sm={5} md={6} lg={8} xl={8} xxl={9} style={{margin:"0 auto",display:"none"}}>
                            <InputGroup className="mb-3" style={{maxWidth:"360px"}}>
                                <InputGroup.Checkbox style={{cursor:"pointer"}} id="batch" onChange={(e) => {
                                        if(e.currentTarget.checked){
                                            setBatchMode(true)
                                            //setUseFilename(true)
                                        } else {
                                            setBatchMode(false)
                                            //document.getElementById("title").removeAttribute("disabled")
                                            //document.getElementById("title").value = ""
                                        }
                                    }} />
                                <Form.Control type="text" value={t("upload.image.batchPosting")} readOnly />
                                <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("一括投稿とは",
                                <span >複数選択したファイルを1ファイル1投稿として連続で投稿できる機能です。<br />
                                一つ一つ投稿する手間を省きます。<br />
                                タイトルや概要などは入力したものがすべての投稿に設定されます。<br />
                                一括投稿を使用しない場合は、複数枚が1ページにまとめて投稿されます。</span>)} />
                            </InputGroup>
                        </Col>
                        <Col xs={6} sm={7} md={6} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            {false && batchMode ? (
                            <InputGroup className="mb-3" style={{maxWidth:"360px"}}>
                                <InputGroup.Checkbox style={{cursor:"pointer",}} id="use_filename" onChange={(e) => {
                                        if(e.currentTarget.checked){
                                            setUseFilename(true)
                                            document.getElementById("title").setAttribute("disabled",e.currentTarget.checked)
                                            document.getElementById("title").value = "<ファイル名が設定されます>"
                                        } else {
                                            setUseFilename(false)
                                            document.getElementById("title").removeAttribute("disabled")
                                            document.getElementById("title").value = ""
                                        }
                                    }} />
                                <Form.Control type="text" style={{fontSize:"12px"}} defaultValue={"タイトルにファイル名を使用する"} readOnly />
                            </InputGroup>
                            ) : ""}
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto"}}>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="title" label={<><span className='required'>必須</span> {t("upload.image.imageTitle")}</>} className="mb-3 w-100">
                                    <Form.Control type="text" placeholder="" required autoComplete="new-password" />
                                </FloatingLabel>
                            </Col>
                            {showQuestionnairePopup ? (
                                <Questionnaire
                                    switch={setShowQuestionnairePopup}
                                    onSave={setQuestionInfo}
                                    options={questionInfo === undefined ? [] : questionInfo.options}
                                    deadlineDate={questionInfo === undefined ? "" : questionInfo.deadlineDate}
                                    deadlineTime={questionInfo === undefined ? "" : questionInfo.deadlineTime}
                                />
                            ) : ""}
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"10px auto"}}>
                                <p className='d-inline '><span className='required'>必須</span> {t("upload.image.styleOfPainting")} </p>
                                <ButtonGroup>
                                    {styles.map((radio, idx) => (
                                        <ToggleButton
                                            className='p-1'
                                            key={idx}
                                            id={`style-${idx}`}
                                            type="radio"
                                            variant={'outline-primary'}
                                            name="style-radio"
                                            value={radio.value}
                                            checked={styleOfPainting === radio.value}
                                            onChange={(e) => {
                                                setStyleOfPainting(e.currentTarget.value)
                                            }}
                                            >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto 10px auto"}}>
                                <p className='d-inline '><span className='required'>必須</span> {t("upload.image.ageLimit")} </p>
                                <ButtonGroup>
                                    {nenrei.map((radio, idx) => (
                                        <ToggleButton
                                            className='p-1'
                                            key={idx}
                                            id={`age-limit-${idx}`}
                                            type="radio"
                                            variant={'outline-primary'}
                                            name="radio"
                                            value={radio.value}
                                            checked={ageLimit === radio.value}
                                            onChange={(e) => {
                                                if(e.currentTarget.value === "2" || e.currentTarget.value === "3"){
                                                    setSexualExpression("")
                                                }
                                                setAgeLimit(e.currentTarget.value)
                                            }}
                                            >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                                {(ageLimit === "2" || ageLimit === "3") && 
                                <Container className='mt-3'>
                                    {t("upload.image.mosaic0")}<br /><br />
                                    <strong>{t("upload.image.mosaic1")}</strong><br />
                                    {t("upload.image.mosaic2")}<br />
                                    {t("upload.image.mosaic3")}<br />
                                    <Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/1.png"} width="300px" style={{border:"1px solid #CCCCCC"}} />
                                    <Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/2.png"} width="300px" style={{marginLeft:"10px",border:"1px solid #CCCCCC"}} />
                                </Container>}
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto 10px auto",display:ageLimit === "1" ? "block" : "none"}}>
                                <p className='d-inline '><span className='required'>必須</span> {t("upload.image.whatIsSexual")} </p>
                                <ButtonGroup>
                                    {yesOrNoRadio.map((radio, idx) => (
                                        <ToggleButton
                                            className='p-1'
                                            key={idx}
                                            id={`sexual-expression-${idx}`}
                                            type="radio"
                                            variant={'outline-primary'}
                                            name="sexual-radio"
                                            value={radio.value}
                                            checked={sexualExpression === radio.value}
                                            onChange={(e) => setSexualExpression(e.currentTarget.value)}
                                            >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                                <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("PG12とは ",
                                        <p>
                                            ■性的表現(軽微なものを含む) 
                                            性的なものを想起させる、接吻、抱擁・下着の露出など。
                                            性行為や類似する動作を連想させる表現や表情。
                                            胸や谷間、乳首、臀部、股間等の強調や際どい表現や構図。
                                            極端に面積の少ない衣類や水着を身に着けた人物の描画や、
                                            露出度の非常に高い人物の描写、透けた衣服を身に着けた人物の描写や全裸等。<br />
                                            ■その他刺激的な表現
                                            殺傷や流血といった残虐性や薬物の登場、児童が真似をする可能性のあるもの
                                        </p>)} />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <Button onClick={() => {
                                    let description = document.getElementById("description")
                                    if(description.value.length === 0){
                                        description.value = "#" + odai
                                    } else {
                                        description.value += " #" + odai
                                    }
                                    setUseOdai(true)
                                    dialog("確認","ハッシュタグ「#" + odai + "」を概要に追加しました。")
                                }}>{t("upload.image.odai1")}「{odai}」{t("upload.image.odai2")}</Button>
                                <p>{t("upload.image.odai3")}</p>
                                <FloatingLabel controlId="description" label={t("upload.image.imageDescription")} className='mb-3 w-100'>
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        onChange={(e) => {
                                            setUseOdai(document.getElementById("description").value.indexOf("#"+odai) !== -1)
                                        }}
                                    />
                                </FloatingLabel>
                                {tagLatest.map(d => <Button variant='secondary' className='m-1 p-1' onClick={() => {
                                    document.querySelector("#description").value += " #" + d
                                }}>+{d}</Button>)}
                                <p>{t("upload.image.tag")}</p>
                                <Typeahead id="tag" placeholder={t("category.tag")} clearButton={true} multiple
                                className='mb-1'
                                onInputChange={(input) => {
                                    tagSearch(input).then(r => {
                                        if(r.result){
                                            setTagOptions(r.data)
                                        }
                                    })
                                }}
                                onChange={(selected) => {
                                    setTag(selected)
                                }}
                                options={tagOptions}
                                />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <Typeahead id="upload-option-select" placeholder={t("upload.image.option")}
                                    className="mb-1"
                                    multiple
                                    clearButton={true}
                                    onChange={(selected) => {
                                        setOptionSelected(selected)
                                    }}
                                    selected={optionSelected}
                                    defaultSelected={[]}
                                    options={[
                                        {label:t("upload.image.original"),value:"original"},
                                        {label:t("upload.image.limitedPublication"),value:"limitedPublication"},
                                        {label:t("upload.image.newPostHidden"),value:"newPostHidden"},
                                        {label:t("upload.image.rankingHidden"),value:"rankingHidden"},
                                        {label:t("upload.image.sensitive"),value:"sensitive"}
                                    ]}
                                    />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <Typeahead id="generation-method-select" placeholder={t("common.generationMethod")}
                                    className="mb-1"
                                    multiple
                                    clearButton={true}
                                    onChange={(selected) => {
                                        setGenearteMethodSelected(selected)
                                    }}
                                    selected={generateMethodSelected}
                                    defaultSelected={[]}
                                    options={[
                                        {label:t("upload.image.t2i"),value:"t2i"},
                                        {label:t("upload.image.i2i"),value:"i2i"},
                                        {label:t("upload.image.inpaint"),value:"inpaint"},
                                        {label:t("upload.image.outpaint"),value:"outpaint"},
                                        {label:t("upload.image.ip2p"),value:"ip2p"},
                                        {label:"ControlNet",value:"ControlNet"}
                                    ]}
                                    />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto 10px auto",display:loginInfo.result !== undefined && loginInfo.result ? "block" : "none"}} className='d-none'>
                                <Typeahead id="series-list" ref={ref} placeholder={"シリーズに追加"} clearButton={true}
                                onChange={(selected) => {
                                    let value = selected.length === 0 ? "" : selected[0]
                                    setSeries(value)
                                }}
                                options={seriesList}
                                />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto 10px auto"}}>
                                開催中・予定のイベント&nbsp;
                                <Icon.InfoCircle style={{fontSize:"20px",cursor:"pointer"}} onClick={() => {
                                    dialog("info",<>
                                    <Link to={"/event"} target='_blank'>イベント情報</Link>として登録されたもののうち、
                                    開催期間3か月前後のものが表示されます。投稿作品に関連付けすることで参加をアピールできます。
                                    </>)
                                }} />
                                <Container className='d-flex justify-content-start'>
                                {eventList.map((d,i) => {
                                    return (<div key={i} style={{border:"1px solid #BBBBBB"}} className='m-3'>
                                        <Thumb data={d} i={i} key={i} list={eventList} type="event" />
                                        <div className='text-center'>
                                            {d.from_datetime} ～<br />{d.to_datetime}<br />
                                            {d.tag !== eventTag ? (
                                            <Button variant='outline-secondary'
                                                onClick={() => setEventTag(d.tag)}
                                            >関連付ける</Button>) : (
                                                <Icon.Check style={{color:"#00FF00",fontSize:"36px",cursor:"pointer"}} onClick={() => setEventTag("") }/>
                                            )}
                                        </div>
                                    </div>)
                                })}
                                </Container>
                                <Link to={"/event"} target='_blank'>イベント一覧</Link><br /><br />
                                <Button variant='outline-secondary' onClick={() => {
                                    dialog("",<>
                                        <Button variant='warning' onClick={() => {
                                            let description = document.getElementById("description")
                                            if(description.value.length === 0){
                                                description.value = "#ノウハウ"
                                            } else {
                                                description.value += " #ノウハウ"
                                            }
                                            dialog("確認","ハッシュタグ「#ノウハウ」を概要に追加しました。")
                                        }}>「ノウハウ」タグを追加</Button>
                                        <p>
                                            自己流生成法の紹介や加筆修正の過程など<br />
                                        </p>
                                        <Button variant='warning' onClick={() => {
                                            let description = document.getElementById("description")
                                            if(description.value.length === 0){
                                                description.value = "#素材"
                                            } else {
                                                description.value += " #素材"
                                            }
                                            dialog("確認","ハッシュタグ「#素材」を概要に追加しました。")
                                        }}>素材として公開(素材タグを追加)</Button>
                                        <p>
                                            #素材タグが付いているものは、誰もが自由に利用できるようになります。<br />
                                            他者の著作物に似たものは素材にはできません。
                                        </p>
                                        <Button variant='warning' onClick={() => {
                                            let description = document.getElementById("description")
                                            if(description.value.length === 0){
                                                description.value = "#AI画像副産物"
                                            } else {
                                                description.value += " #AI画像副産物"
                                            }
                                            dialog("確認","ハッシュタグ「#AI画像副産物」を概要に追加しました。")
                                        }}>「AI画像副産物」タグを追加</Button>
                                        <p>失敗したけど味がある。目的のものとは違うけどいいものが出力された場合、など。</p>
                                        <Button variant='warning' onClick={() => {
                                            let description = document.getElementById("description")
                                            if(description.value.length === 0){
                                                description.value = "#ネタ画像"
                                            } else {
                                                description.value += " #ネタ画像"
                                            }
                                            dialog("確認","ハッシュタグ「#ネタ画像」を概要に追加しました。")
                                        }}>「ネタ画像」タグを追加</Button>
                                        <p>生成の過程で思いもよらない面白いものやネタ的な画像が出力された場合、など。</p>
                                        <Button variant='warning' onClick={() => {
                                            let description = document.getElementById("description")
                                            if(description.value.length === 0){
                                                description.value = "#物語を感じるAIアート"
                                            } else {
                                                description.value += "#物語を感じるAIアート"
                                            }
                                            dialog("確認","ハッシュタグ「#物語を感じるAIアート」を概要に追加しました。")
                                        }}>「物語を感じるAIアート」タグを追加</Button>
                                        <p>概要欄に短い物語が書いてあると良いでしょう。</p>
                                        <Button variant='warning' onClick={() => {
                                            let description = document.getElementById("description")
                                            if(description.value.length === 0){
                                                description.value = "#漫画"
                                            } else {
                                                description.value += "#漫画"
                                            }
                                            dialog("確認","ハッシュタグ「#漫画」を概要に追加しました。")
                                        }}>「漫画」タグを追加</Button>
                                        <p><a href="https://twitter.com/jonigata_ai" target={"_blank"} rel="noreferrer">AI生成画像向き簡易マンガ制作ツール</a></p>
                                        <b>タグを関係のない作品につけた場合は修正する場合があります。</b>
                                    </>)
                                }}>タグ候補の案</Button>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto",border:"3px solid #CCCCCC",padding:"10px",borderRadius:"5px",display:"none"}}>
                                <Link to={"https://twitter.com/ourt_ai/status/1671962304546762752"} target='_blank'>
                                <img
                                    className="d-block w-100"
                                    src="/img/horror202306.webp"
                                    alt="投稿企画「ホラー」"
                                    style={{objectFit:"contain",width:"100%",height:"100%"}}
                                />
                                </Link>
                                <Button variant='warning' onClick={() => {
                                    let description = document.getElementById("description")
                                    if(description.value.length === 0){
                                        description.value = "#ホラー"
                                    } else {
                                        description.value += "#ホラー"
                                    }
                                    dialog("確認","ハッシュタグ「#ホラー」を概要に追加しました。")
                                }} disabled>企画に参加(タグを追加)</Button>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto",border:"3px solid #CCCCCC",padding:"10px",borderRadius:"5px",display:"none"}}>
                                <h5>「和気あいAI」 AIイラスト、グッズ等展示即売会のイメージイラストへの応募</h5>
                                <p>
                                <Button variant="warning" onClick={() => {
                                    let description = document.getElementById("description")
                                    description.value += (description.value.length === 0 ? "":"\n") + "#和気あいAI202309"
                                    dialog("確認","参加用のハッシュタグを概要に追加しました。")
                                }}>イメージイラストに応募する(応募タグを追加)</Button><br />
                                応募期限：2023/6/30  23:59まで<br />
                                <Link to={"https://twitter.com/ko_to_ba_no_aya/status/1659724898934341633"} target='_blank'>募集要項</Link><br />
                                <Link to={"/event/fd392f6e-b02f-4fe4-8fe3-a4aedd7d7bec"} target='_blank'>イベント詳細</Link>
                                </p>
                            </Col>
                        </Col>
                        <hr />
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto"}}>
                            {fileList.length > 0 && fileList[editImageNo] ? (
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="m-1">
                                    <Container style={{width:"240px",height:"auto",display:"block"}}>
                                        <Container className='text-center'>
                                            {t("upload.image.edittingInfo")}
                                        </Container>
                                        <Container className='d-flex justify-content-between mb-3'>
                                            <Button onClick={() => {
                                                if(editImageNo > 0){
                                                    setEditImageNo(editImageNo - 1)
                                                }
                                                }} disabled={editImageNo === 0}>
                                                <Icon.ArrowLeft /></Button>
                                            <Button onClick={() => {
                                                if(editImageNo < fileList.length){
                                                    setEditImageNo(editImageNo + 1)
                                                }
                                                }} disabled={editImageNo === fileList.length - 1} >
                                                <Icon.ArrowRight /></Button>
                                        </Container>
                                        <Container>
                                            <Image alt={fileList[editImageNo].file.name} src={fileList[editImageNo].imageDataMiddle} id="select-img" style={{objectFit:"contain",width:"100%",height:"100%",cursor:"pointer"}}
                                            onClick={(e) => {
                                                setPreviewSource(fileList[editImageNo].useMosaic === "1" ? fileList[editImageNo].imageDataEdited : fileList[editImageNo].imageDataOriginal)
                                                setPreviewFlg(true)
                                            }}/>
                                        </Container>
                                    </Container>
                                </Col>
                            ) : ""}
                            <Col xs={6} sm={6} md={6} lg={4} xl={3} xxl={3} style={{margin:"40px auto"}}>
                                <Button className='mb-3' variant='outline-danger' onClick={() => deleteSelectedFormValue()}>
                                    {t("upload.image.deleteCurrentInfo")}
                                </Button>
                                <p style={{display:"block"}}>{t("upload.image.useModelRequired")}</p>
                                <Typeahead id="ai-model-input" ref={ref} placeholder={"Search"} clearButton={true}
                                onInputChange={(input) => {
                                    let value = input === undefined ? "no-select" : input
                                    if(fileList.length > 0){
                                        fileList[editImageNo].software = value
                                    }
                                    document.getElementById("ai-model").value = value
                                }}
                                onChange={(selected) => {
                                    let value = selected.length === 0 ? "no-select" : selected[0]
                                    if(fileList.length > 0){
                                        fileList[editImageNo].software = value
                                    }
                                    document.getElementById("ai-model").value = value
                                }}
                                disabled={fileList.length > 0 && fileList[editImageNo].useAIGeneration}
                                options={[
                                    "StableDiffusion",
                                    "StableDiffusion_v1-1",
                                    "StableDiffusion_v1-2",
                                    "StableDiffusion_v1-3",
                                    "StableDiffusion_v1-4",
                                    "StableDiffusion_v2-1",
                                    "StableDiffusion_XL",
                                    "NovelAI",
                                    "HolaraAI",
                                    "未使用",
                                    "マージモデル_名称なし",
                                    "オリジナルモデル",
                                    "Agelesnate",
                                    "AgelesnateV1_1",
                                    "AgelesnateV1_2",
                                    "animelike25D",
                                    "Aurora_v1.0",
                                    "AnythingV3",
                                    "AnythingV4",
                                    "AnythingV4.5",
                                    "AbyssOrangeMix",
                                    "AbyssOrangeMix2",
                                    "AbyssOrangeMix3",
                                    "ACertainThing",
                                    "ACertainModel",
                                    "ACertainty",
                                    "AikimiD1",
                                    "AikimiXW1",
                                    "AikimiXR1",
                                    "AikimiXR2",
                                    "AikimiXR3",
                                    "AikimiXR4",
                                    "AikimiXR5",
                                    "Aikimi_dB4",
                                    "Aikimi_dC3",
                                    "Aikimi_dC4",
                                    "AikiliMX2",
                                    "blue_pencil-v1",
                                    "blue_pencil-v1b",
                                    "blue_pencil-v2",
                                    "blue_pencil-v2b",
                                    "blue_pencil-v3",
                                    "blue_pencil-v4",
                                    "blue_pencil-v5",
                                    "blue_pencil-v5b",
                                    "blue_pencil-v6",
                                    "blue_pencil-v7",
                                    "blue_pencil-v8",
                                    "blue_pencil-v9",
                                    "blue_pencil-v9b",
                                    "blue_pencil-v10",
                                    "blue_pencil_realistic-v0.1",
                                    "EverlastingV2",
                                    "7th_anime_v3_testA",
                                    "7th_anime_v3_testB",
                                    "7th_anime_v3_testC",
                                    "7th_anime_3.1_A",
                                    "7th_anime_3.1_B",
                                    "7th_anime_3.1_C",
                                    "7th_anime_3.1_Cg",
                                    "7th_anime_v2.1_B",
                                    "Baka-DiffusionV1",
                                    "CounterfeitV1.0",
                                    "CounterfeitV2.0",
                                    "CounterfeitV2.2",
                                    "CounterfeitV2.5",
                                    "CounterfeitV3.0",
                                    "CinnamonMix",
                                    "ChilloutMix",
                                    "chilled_remix_v1Fp16vae",
                                    "chilled_remix_v1vae",
                                    "chilled_remixb_v1vae",
                                    "chilled_reversemix_v1vae",
                                    "Defmix",
                                    "demiPeroMixV1",
                                    "demiPeroMixV2",
                                    "DivineEleganceMixV1",
                                    "DivineEleganceMixV2",
                                    "DivineEleganceMixV3",
                                    "Elysium_V1",
                                    "Elysium_Anime_V1",
                                    "Elysium_Anime_V2",
                                    "Elysium_Anime_V3",
                                    "Elysium_Kuro_Anime_V1",
                                    "HentaiDiffusion",
                                    "Hassaku_V1to1.2-inpainting",
                                    "Hassaku_V1",
                                    "Hassaku_V1m",
                                    "Hassaku_V1.1",
                                    "Hassaku_V1.2",
                                    "OsukiniMix_A",
                                    "OsukiniMix_B",
                                    "OsukiniMix_B_V2",
                                    "SEmix_V1_A",
                                    "SEmix_V1_B",
                                    "SEmix_V1_C",
                                    "SEmix_V2_A",
                                    "SEmix_V2_B",
                                    "Shining_Mix_V1",
                                    "Shining_Mix_V2",
                                    "Shirayuki_General_V1",
                                    "Shirayuki_Anime_V1",
                                    "SukumizuMix",
                                    "WaifuDiffusion",
                                    "SukiyakiMix",
                                    "SukiAnimix",
                                    "majicmixRealistic_v6",
                                    "Midjourney",
                                    "Midjourney_V5",
                                    "Microsoft Bing Image Creator",
                                    "milktea_mild_V1",
                                    "niji・journey",
                                    "niji・journey_V5",
                                    "TrinArt",
                                    "Dalle-2",
                                    "Ernie-vilg",
                                    "UnstableDiffusion",
                                    "MeituAIPainting",
                                    "Rivera",
                                    "PastelMix",
                                    "PerfectSketchbook",
                                    "Protogen",
                                    "お絵描きばりぐっどくん",
                                    "えいあーとAI",
                                    /*"ourt AI Diffusion (Anime V1)",*/
                                    "ourt AI Diffusion (Anime V2)"
                                    ]}
                                />
                                <FloatingLabel controlId="ai-model" label={t("upload.image.useModel")} className="mb-3" style={{display:"block"}}>
                                    <Form.Control type="text" placeholder=""
                                        disabled={fileList.length > 0 && fileList[editImageNo].useAIGeneration}
                                        onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].software = e.currentTarget.value
                                    }} />
                                </FloatingLabel>
                                <Button className='mb-0 d-none' variant='outline-primary' onClick={() => {
                                    let model = document.getElementById("ai-model").value
                                    if(model === "" || model === "no-select"){
                                        dialog("確認",t("upload.image.useModelRequired"))
                                        return
                                    }
                                    fileList.forEach(d => {
                                        d.software = model
                                    })
                                    dialog("確認",t("upload.image.useModelLeft")+"「"+model+"」"+t("upload.image.useModelRight"))
                                }}>
                                    {t("upload.image.allUseSameModel")}
                                </Button>
                            </Col>
                            <Col xs={6} sm={6} md={6} lg={4} xl={3} xxl={3} style={{margin:"30px auto",display:"none"}}>
                                <FloatingLabel controlId="model-version" label={t("upload.image.modelVersion")} className="mb-3" style={{display:"block"}}>
                                    <Form.Control type="text" placeholder="" readOnly disabled />
                                </FloatingLabel>
                            </Col>
                            <Col xs={6} sm={6} md={6} lg={4} xl={3} xxl={3} style={{margin:"10px auto",display:promptInfoPublication && false ? "block" : "none"}}>
                                <Form.Control type="file" encType="multipart/form-data" accept="*.*" className='d-none' id="read-prompt-info-file" onChange={(e) => {
                                    let img = new ImageFile({file:e.currentTarget.files[0]})
                                    setMetaData(e.currentTarget.files[0],img).then(r => {
                                        setMetaDataField(img,true)
                                        if(editImageNo !== -1){
                                            fileList[editImageNo].prompt = img.prompt
                                            fileList[editImageNo].software = img.software
                                            fileList[editImageNo].modelHash = img.modelHash
                                            fileList[editImageNo].comment = img.comment
                                        }
                                    })
                                    e.currentTarget.value = ""
                                }} />
                                <Button className='d-none' variant='outline-primary' onClick={() => document.getElementById("read-prompt-info-file").click()}>プロンプト情報だけ読み込む</Button>
                            </Col>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto",display:promptInfoPublication ? "block" : "none"}}>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="prompt" label={t("upload.image.promptName")} className='mb-3 w-100' style={{display:"block"}}>
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].prompt = e.currentTarget.value
                                        }}
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="negative-prompt" label={t("upload.image.negativePromptName")} className='mb-3 w-100' style={{display:"block"}}>
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.uc = e.currentTarget.value
                                        }}
                                    />
                                </FloatingLabel>
                            </Col>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto",display:promptInfoPublication && false ? "block" : "none"}}>
                            <Row>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="noise" label="Noise" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.noise = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="steps" label="Steps" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.steps = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="scale" label="Scale" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.scale = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="seed" label="Seed" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.seed = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="sampler" label="Sampler" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.sampler = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="strength" label="Denoising strength" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.strength = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="mask-blur" label="Mask blur" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.maskBlur = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="clip-skip" label="Clip skip" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.clipSkip = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="ensd" label="ENSD" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.ensd = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="hires-upscale" label="Hires Upscale" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.maskBlur = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="hires-upscaler" label="Hires Upscaler" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.hiresUpscaler = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="controlnet-enabled" label="ControlNet Enabled" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.controlNetEnabled = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="controlnet-module" label="ControlNet Module" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.controlNetModule = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="controlnet-model" label="ControlNet Model" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.controlNetModel = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="controlnet-weight" label="ControlNet Weight" className="mb-3" style={{display:"block"}} autoComplete="new-password">
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.controlNetWeight = e.currentTarget.value
                                        }} autoComplete="new-password" />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="raw-info" label={"rawinfo"} className='mb-3 w-100' style={{display:"block"}}>
                                        <Form.Control
                                            as="textarea"
                                            style={{ height: '100px' }}
                                            required
                                            onChange={(e) => {
                                                if(fileList.length > 0)
                                                fileList[editImageNo].rawInfo = e.currentTarget.value
                                            }}
                                        />
                                    </FloatingLabel>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            <Accordion flush style={{border:"1px solid #CCCCCC"}} className="mb-3">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header><RIcon.FaDesktop style={{fontSize:"18px"}} />&nbsp;{t("common.others")}</Accordion.Header>
                                        <Accordion.Body>
                                            <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto",width:"100%"}}>
                                                <Typeahead id="vae" placeholder={"VAE"} clearButton={true}
                                                onInputChange={(input) => {
                                                    let value = input === undefined ? "" : input
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].vae = value
                                                        setVAE([value])
                                                    }
                                                }}
                                                onChange={(selected) => {
                                                    let value = selected.length === 0 ? "" : selected[0]
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].vae = value
                                                        setVAE([value])
                                                    }
                                                }}
                                                options={[
                                                    "Anything-V3.0.vae",
                                                    "anything-v4.0.vae",
                                                    "autoencoder_fix_kl-f8-trinart_characters",
                                                    "ACertainModel.vae",
                                                    "Baka-Diffusion.vae",
                                                    "clearvae_main.safetensors",
                                                    "vae-ft-ema-560000-ema-pruned",
                                                    "vae-ft-mse-840000-ema-pruned",
                                                    "kl-f8-anime",
                                                    "kl-f8-anime2",
                                                    "mse840000_klf8anime.vae",
                                                    "mse840000_klf8anime_klf8anime2.vae",
                                                    ]}
                                                selected={vae}
                                                />
                                            </Col>
                                            <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto",width:"100%"}}>
                                                <Typeahead id="gpu" placeholder={"GPU"} clearButton={true}
                                                onInputChange={(input) => {
                                                    let value = input === undefined ? "" : input
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].gpu = value
                                                        setGPU([value])
                                                    }
                                                }}
                                                onChange={(selected) => {
                                                    let value = selected.length === 0 ? "" : selected[0]
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].gpu = value
                                                        setGPU([value])
                                                        console.log(selected)
                                                    }
                                                }}
                                                options={[
                                                    "GeForce GTX 950","GeForce GTX 960","GeForce GTX 970","GeForce GTX 980","GeForce GTX 980 Ti",
                                                    "GeForce GTX 950M (Notebooks)","GeForce GTX 960M (Notebooks)","GeForce GTX 965M (Notebooks)","GeForce GTX 970M (Notebooks)","GeForce GTX 980M (Notebooks)","GeForce GTX 980 (Notebooks)",
                                                    "GeForce GTX 1050","GeForce GTX 1050 Ti","GeForce GTX 1060","GeForce GTX 1070","GeForce GTX 1070 Ti","GeForce GTX 1080","GeForce GTX 1080 Ti",
                                                    "GeForce GTX 1050 (Notebooks)","GeForce GTX 1050 Ti (Notebooks)","GeForce GTX 1060 (Notebooks)","GeForce GTX 1070 (Notebooks)","GeForce GTX 1080 (Notebooks)",
                                                    "Geforce GTX 1630","Geforce GTX 1650","Geforce GTX 1650 SUPER","Geforce GTX 1660","Geforce GTX 1660 Ti","Geforce GTX 1660 SUPER",
                                                    "Geforce GTX 1650 (Notebooks)","Geforce GTX 1650 Ti (Notebooks)","Geforce GTX 1660 Ti (Notebooks)",
                                                    "GeForce RTX 2050 (Notebooks)","GeForce RTX 2060 (Notebooks)","GeForce RTX 2070 (Notebooks)","GeForce RTX 2070 SUPER (Notebooks)","GeForce RTX 2080 (Notebooks)","GeForce RTX 2080 SUPER (Notebooks)",
                                                    "GeForce RTX 2060","GeForce RTX 2060 SUPER","GeForce RTX 2070","GeForce RTX 2070 SUPER","GeForce RTX 2080","GeForce RTX 2080 SUPER","GeForce RTX 2080 Ti",
                                                    "GeForce RTX 3050","GeForce RTX 3060","GeForce RTX 3060 Ti","GeForce RTX 3070","GeForce RTX 3070 Ti","GeForce RTX 3080","GeForce RTX 3080 Ti","GeForce RTX 3090","GeForce RTX 3090 Ti",
                                                    "GeForce RTX 3050 Laptop GPU","GeForce RTX 3050 Ti Laptop GPU","GeForce RTX 3060 Laptop GPU","GeForce RTX 3070 Laptop GPU","GeForce RTX 3070 Ti Laptop GPU","GeForce RTX 3080 Laptop GPU","GeForce RTX 3080 Ti Laptop GPU",
                                                    "GeForce RTX 4070 Ti","GeForce RTX 4080","GeForce RTX 4090",
                                                    "GeForce RTX 4050 Laptop GPU","GeForce RTX 4060 Laptop GPU","GeForce RTX 4070 Laptop GPU","GeForce RTX 4080 Laptop GPU","GeForce RTX 4090 Laptop GPU",
                                                    "NVIDIA A100"
                                                    ]}
                                                selected={gpu}
                                                />
                                            </Col>
                                            <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto",width:"100%"}}>
                                                <Typeahead id="vram" placeholder={"VRAM"} clearButton={true}
                                                onInputChange={(input) => {
                                                    let value = input === undefined ? "" : input
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].vram = value
                                                        setVRAM([value])
                                                    }
                                                }}
                                                onChange={(selected) => {
                                                    let value = selected.length === 0 ? "" : selected[0]
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].vram = value
                                                        setVRAM([value])
                                                    }
                                                }}
                                                options={["1GB","2GB","4GB","6GB","8GB","12GB","16GB","24GB","32GB","36GB","48GB"]}
                                                selected={vram}
                                                />
                                            </Col>
                                        </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto",display:loginInfo.result === false ? "block" : "none"}}>
                            <hr />
                            ログインせずに匿名投稿できます。<br />削除パスワードを設定してください。
                            <FloatingLabel controlId="delete-password" label="削除パスワード" className='mb-3'>
                                <Form.Control type="password" cows="10" autoComplete="new-password" />
                            </FloatingLabel>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            <hr />
                            <FloatingLabel controlId="request" label={t("upload.image.requestMessage")} className='mb-3 w-100' style={{display:"block"}}>
                                <Form.Control
                                    as="textarea"
                                    style={{ height: '100px' }}
                                    required
                                />
                            </FloatingLabel>
                            <div
                                title={t("questionnaire.title")}
                                onClick={() => {
                                    setShowQuestionnairePopup(true)
                                }}
                                style={{margin:"0 auto",marginBottom:"20px",cursor:"pointer",display:"inline"}}
                            >
                                <div style={{border:"1px solid #555555",display:"inline"}} className="p-1">
                                <Icon.ListOl style={{fontSize:"30px"}}/>{t("questionnaire.title")}
                                &nbsp;
                                {questionInfo !== undefined && questionInfo.deadlineDate.length > 0 ? <Icon.CheckLg style={{color:"green"}} /> : ""}
                                </div>
                            </div>
                            <div style={{margin:"0 auto",marginBottom:"20px",cursor:"pointer",display:"inline"}} className='p-1'>
                                <div style={{border:"1px solid #555555",display:"inline"}} className="p-1"
                                    onClick={() => {
                                        dialog(t("common.scheduledPost"),
                                        <Container>
                                            <Container>
                                                <FloatingLabel controlId="booking-date" label={t("upload.image.bookingYmd")} className='mb-3 w-100'>
                                                    <Form.Control
                                                        type="date"
                                                        required
                                                        defaultValue={bookingDate}
                                                        onChange={(e) => setBookingDate(e.currentTarget.value)}
                                                    />
                                                </FloatingLabel>
                                            </Container>
                                            <Container>
                                                <FloatingLabel controlId="booking-time" label={t("upload.image.bookingHi")} className='mb-3 w-100'>
                                                    <Form.Control
                                                        type="time"
                                                        required
                                                        defaultValue={bookingTime}
                                                        onChange={(e) => setBookingTime(e.currentTarget.value)}
                                                    />
                                                </FloatingLabel>
                                                <Button className="mb-3" onClick={() => {
                                                    document.getElementById("booking-date").value = ""
                                                    document.getElementById("booking-time").value = ""
                                                    setBookingDate("")
                                                    setBookingTime("")
                                                }}>{t("upload.image.clearBooking")}</Button>
                                            </Container>
                                        </Container>
                                        )
                                    }}
                                >
                                    <Icon.Clock />
                                    {t("common.scheduledPost")}
                                </div>
                            </div>
                            <div>
                                <Button variant="danger" style={{marginTop:"10px",marginBottom:"10px",width:"200px"}} onClick={(e) => uploadHandler(e)} disabled={uploading}>{t("upload.image.upload")}{uploading ? <> <Spinner animation="border" size="sm" /></> : ""}</Button>
                                <Button variant="danger" style={{position:"fixed",zIndex:2,left:window ? (window.innerWidth - 200) / 2 : 0,bottom:"20px",width:"200px"}} onClick={(e) => uploadHandler(e)} disabled={uploading}>
                                    {t("upload.image.upload")}
                                    {uploading && (<><br /><ProgressBar id="progress" animated now={progressNow} label={`${progressLabel}`} /></>)}
                                </Button>
                            </div>
                            <p>
                                <Link to='/terms'>利用規約</Link>に違反する投稿は削除の対象となります。
                            </p>
                            <p>
                                要望や不具合報告、その他アワートAIに関する更新情報の告知などは公式Discordでも行っています。<br />
                                <Icon.Discord /> <a href="https://discord.gg/vQNvaCXYvu" alt="Official Discord" target={"_blank"} rel="noreferrer">Official Discord</a>
                            </p>
                            <Button variant='contained' onClick={() => planDialog(dialog)}>支援について</Button><br />
                            <br />
                            {loginInfo.plan === "basic" || loginInfo.plan === "certification" || loginInfo.plan === "unlimited" || loginInfo.plan === "plus" ? "" : (
                            <iframe src="https://rcm-fe.amazon-adsystem.com/e/cm?o=9&p=294&l=ur1&category=monthlydealevent&banner=182WYJSVKYZPCAT1BKR2&f=ifr&linkID=1aab21e0581aead54e632cabea7ed4e1&t=ourt-ai-22&tracking_id=ourt-ai-22" width="320" height="100" scrolling="no" border="0" marginWidth="0" style={{border:"none"}} frameBorder="0" sandbox="allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation"></iframe>
                            )}
                            <div>
                                <hr />
                                {t("upload.image.hasPoint")}：<b>{point}</b><br />
                                {t("upload.image.last6Month")}：<b>{calcPointInfo.avg}</b><br />
                                <b>{calcPointInfo.addPoint}</b>{t("upload.image.point")} / 1 {t("upload.image.unit")}<br />
                                <hr />
                                {t("upload.image.getPointTotal")}：<b>{useOdai ? calcPointInfo.point * 2 : calcPointInfo.point}</b>{useOdai ? " ("+t("common.odaiBonus")+")" : ""}<br />
                                {t("upload.image.odai1")}{t("upload.image.odai2")}：<b>{useOdai ? t("common.yes") : t("common.no")}</b><br />
                                {t("upload.image.review")}
                            </div>
                        </Col>
                    </Row>
                    </Form>
        </Container>
        {postedGroupId === "" ? (<Footer />) : ""}
    </div>
    </>
    )
}

export default UploadVideo;
